(function () {
// Sections
const $5360e0e42e381604$var$article = {
    init: ()=>{
        const $parent = $(".template-article");
        if ($parent.length > 0) {
            const $card = document.querySelector(".Article__CardWrapper");
            let childrenCount = $(".Article__CardWrapper").children().length > 0;
            let doFixedATC = childrenCount > 0 ? true : false;
            if (doFixedATC) {
                // Adjust existing card
                const $newTitle = document.createElement("div");
                $newTitle.classList.add("title-price");
                const $cardHeading = $card.querySelector(".ProductCardHeading");
                const $cardPrice = $card.querySelector(".ProductCardPrice");
                $newTitle.appendChild($cardHeading);
                $newTitle.appendChild($cardPrice);
                // Insert completed fix
                const $infoWrap = $card.querySelector(".ProductCart__Info");
                const $subhead = $infoWrap.querySelector(".ProductCardSubheading");
                $infoWrap.insertBefore($newTitle, $subhead);
                // Build fixed ATC
                const $fixedATC = document.createElement("div");
                $fixedATC.classList.add("Article__FixedATC");
                $fixedATC.setAttribute("role", "region");
                $fixedATC.setAttribute("aria-label", "Sticky Add to Cart");
                $fixedATC.innerHTML = `
                <div class="fixed-atc__info-wrapper">
                <div class="fixed-atc__image"></div>
                <div class="fixed-atc__text"></div>
                </div>
                <div class="fixed-atc__btn"></div>
            `;
                // Copy card nodes to fixed ATC
                const $image = $card.querySelector(".ProductCardImage").cloneNode(true);
                const $titlePrice = $newTitle.cloneNode(true);
                const $atcButton = $card.querySelector("[data-quick-add]").cloneNode(true);
                const $altButton = $card.querySelector("[data-quick-add]").cloneNode(true);
                $fixedATC.querySelector(".fixed-atc__image").appendChild($image);
                $fixedATC.querySelector(".fixed-atc__text").appendChild($titlePrice);
                $fixedATC.querySelector(".fixed-atc__btn").appendChild($atcButton);
                const $btnAlt = document.createElement("div");
                $btnAlt.classList.add("fixed-atc__btn-alt");
                $btnAlt.appendChild($altButton);
                $fixedATC.querySelector(".fixed-atc__text").appendChild($btnAlt);
                // Insert fixed ATC
                const $info = document.getElementById("shopify-section-article-info");
                $info.appendChild($fixedATC);
            }
            // Throttle function
            function throttle(fn, wait) {
                var time = Date.now();
                return function() {
                    if (time + wait - Date.now() < 0) {
                        fn();
                        time = Date.now();
                    }
                };
            }
            // Check on scroll
            $(window).on("scroll", throttle(function() {
                if (doFixedATC) checkBlockVisible();
            }, 200));
            function checkBlockVisible() {
                $(".Article__CardWrapper").each(function() {
                    let buffer = 0;
                    let block_height = $(this).outerHeight();
                    let scroll_top = $(window).scrollTop();
                    let offset_top = $(this).offset().top;
                    let window_height = $(window).height();
                    let bottom = scroll_top + window_height + buffer;
                    let distance = offset_top + block_height - buffer - scroll_top;
                    // console.log(`bottom: ${bottom} offset_top: ${offset_top} distance: ${distance}`)
                    if (distance > 0) // Show normal card
                    $("body").removeClass("fixed-card");
                    else // Show fixed ATC
                    $("body").addClass("fixed-card");
                });
            }
            checkBlockVisible();
        }
    }
};
var $5360e0e42e381604$export$2e2bcd8739ae039 = $5360e0e42e381604$var$article;


const $c0698e6676883e31$var$blog = {
    init: ()=>{
        var selectors = {
            subheaderContainer: ".Subheader",
            subheaderLink: ".Subheader__Link",
            subheaderLinkAll: "[data-all-articles]"
        };
    /* $(selectors.subheaderContainer).on('click', selectors.subheaderLink, (e) => {
            e.preventDefault();
            
            const target = e.target,
                href = $(target).attr('href'),
                hrefAll = $(selectors.subheaderLinkAll).attr('href');

            $.ajax({
                url: href,
                method: 'GET',
                success: function (data) {
                    var drawerInner = $('.Blog');

                    drawerInner.html(data);
                },
                error: function (error) {
                    $.ajax({
                        url: hrefAll,
                        method: 'GET',
                        success: function (data) {
                            var drawerInner = $('.Blog');

                            drawerInner.html(data);
                        }
                    });
                }
            });
            
            $(selectors.subheaderLink)
                    .removeClass('Subheader__Link--Active')
                    .eq($(selectors.subheaderLink).index($(target)))
                    .addClass('Subheader__Link--Active');
        }); */ }
};
var $c0698e6676883e31$export$2e2bcd8739ae039 = $c0698e6676883e31$var$blog;


const $1c739f26630ae9d4$var$cart_drawer = {
    init: ()=>{
        document.documentElement.style.setProperty("--drawer-footer-and-header-height", $("#sidebar-cart .Drawer__Footer").outerHeight() + $("#sidebar-cart .Drawer__CartHeader").outerHeight() + 40 + "px");
        var selectors = {
            addToCart: "[data-add-to-cart]",
            sideBarCart: "#sidebar-cart",
            openCart: '[data-action="open-cart"]',
            closeCart: '[data-action="close-cart"]',
            tradeSelect: "[data-profession-dropdown]",
            checkoutBtn: '[name="checkout"]',
            checkoutWithDiscount: "[data-checkout-with-discount]",
            quantitySelectors: '[data-action="update-item-quantity"], [data-action="remove-item"]',
            changeQuantity: ".QuantitySelector__CurrentQuantity",
            selectorQuantity: ".QuantitySelector__Quantity",
            qty: ".js-qty__adjust",
            variantSelect: ".CartItem__VariantSelect",
            productQuantityInput: ".Product__QuantityInput",
            cartItem: ".CartItem",
            itemCounts: ".Drawer__FooterInfoItemCounts",
            cartCount: ".CartCount",
            quickAdd: "[data-quick-add]",
            addToCartErrorContainer: "[data-cart-error]",
            form: '[action="/cart/add"]',
            productPrice: "[data-product-price]",
            comparePrice: "[data-compare-price-update-price]",
            containersWithPrice: "[data-for-update-price]"
        };
        var original_selector;
        function cartDrawer(container) {
            this.$container = $(container);
            var options = {
                test: this.$container.find(".Product__Content") || false
            };
            $(document).on("click", selectors.quantitySelectors, function(e) {
                updateItemQuantity(e, this);
            });
            $(document).on("change", selectors.changeQuantity, function(e) {
                updateItemQuantity(e, this);
            });
            function updateItemQuantity(event, target) {
                event.preventDefault();
                var quantity = null, elementToAnimate = null;
                if (target.tagName === "INPUT") quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
                else quantity = parseInt(target.getAttribute("data-quantity"));
                // If the quantity is 0, then we will animate the product with a removal effect
                if (quantity === 0) elementToAnimate = target.closest(selectors.cartItem);
                const id = $(target).data("line-key");
                const data = {
                    updates: {
                        [id]: quantity
                    }
                };
                if ($(target).attr("data-bundle-keys")) {
                    const bundle_keys = $(target).attr("data-bundle-keys").split(", ");
                    bundle_keys.forEach((item)=>{
                        data.updates[item] = quantity;
                    });
                }
                $.ajax({
                    url: `/cart/update.js`,
                    cache: false,
                    type: "post",
                    data: data,
                    success: function(itemData) {
                        renderCart(elementToAnimate);
                    //setTimeout(disableQuantityButtons, 800);
                    },
                    error: function(error) {
                        console.log(error);
                    }
                });
            }
            function disableQuantityButtons() {
                const cartItems = $(".QuantitySelector__CurrentQuantity");
                let data = [];
                cartItems.each(function(index, item) {
                    const $el = $(this), id = $el.data("line-id");
                    data[id] = (data[id] || 0) + parseInt($el.val());
                });
                Object.keys(data).forEach((vid)=>{
                    if (data[vid] >= $(`.QuantitySelector__CurrentQuantity[data-line-id=${vid}]`).attr("max")) $(`.QuantitySelector__CurrentQuantity[data-line-id=${vid}]`).siblings(".QuantitySelector__Button--Plus").addClass("Disabled");
                    else $(`.QuantitySelector__CurrentQuantity[data-line-id=${vid}]`).siblings(".QuantitySelector__Button--Plus").removeClass("Disabled");
                });
            }
            function renderCart(elementToAnimate, notRender = false) {
                if (elementToAnimate !== null) $(elementToAnimate).fadeOut();
                fetch("/?section_id=cart-drawer&timestamp=" + Date.now(), {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(content) {
                    content.text().then(function(html) {
                        var count = parseInt($(html).find(selectors.itemCounts).attr("data-count"));
                        if (isNaN(count)) count = 0;
                        $(selectors.sideBarCart).html($(html).find(".Drawer__Container"));
                        $(selectors.cartCount).html(count);
                        $("[data-cart-count]").html(count);
                        document.documentElement.style.setProperty("--drawer-footer-and-header-height", $("#sidebar-cart .Drawer__Footer").outerHeight() + $("#sidebar-cart .Drawer__CartHeader").outerHeight() + 40 + "px");
                        if (!notRender) {
                            if ($('.Drawer[aria-hidden="true"]').length) {
                                var $drawer = $('#sidebar-cart.Drawer[aria-hidden="true"]');
                                openCartDrawer($drawer);
                            } else {
                                bodyScrollLock.disableBodyScroll($("#sidebar-cart").find("#EnableScroll")[0]);
                                bodyScrollLock.disableBodyScroll($("#sidebar-cart").find(".Drawer__CartList")[0]);
                            }
                        }
                        setTimeout(function() {
                            checkingHideShowBtn();
                        }, 500);
                    });
                });
            }
            $("body").on(":addToCart", function(e) {
                renderCart();
            //setTimeout(disableQuantityButtons, 800);
            });
            function openCartDrawer(drawer) {
                var $overlay = $(".PageOverlay");
                drawer.attr("aria-hidden", false);
                $overlay.addClass("Is-visible").css("z-index", "17");
                bodyScrollLock.disableBodyScroll($("#EnableScroll")[0]);
                bodyScrollLock.disableBodyScroll($(".Drawer__CartList")[0]);
                // $(selectors.openCart).attr('aria-expanded', true);
                handleIntelligems();
                setTimeout(function() {
                    $(".Drawer__CartHeaderClose").get(0).focus();
                }, "500");
            }
            function closeCartDrawer(drawer, overlay) {
                console.log("closing cart drawer!");
                overlay.removeClass("Is-visible").css("z-index", "11");
                drawer.attr("aria-hidden", true);
                bodyScrollLock.clearAllBodyScrollLocks();
                $("body").attr("style", "");
                setTimeout(function() {
                    console.log("focusing original_selector", original_selector);
                    original_selector.get(0).focus();
                });
            }
            // ---- Remove cart items which was sold out
            function checkForRemainder() {
                const soldOutItems = [];
                $(selectors.changeQuantity).each((index, item)=>{
                    if ($(item).attr("max") <= 0) soldOutItems.push(0);
                    else soldOutItems.push(parseInt($(item).val()));
                });
                if (soldOutItems.includes(0)) $.ajax({
                    url: "/cart/update.js",
                    dataType: "json",
                    type: "POST",
                    data: {
                        updates: soldOutItems
                    },
                    success: function(itemData) {
                        renderCart($(`${selectors.changeQuantity}[max=0]`).closest(selectors.cartItem), true);
                    },
                    error: function(error) {
                        console.log(error);
                    }
                });
            }
            $(document).on("click", selectors.openCart, function(e) {
                original_selector = $(this);
                // console.log('original_selector (openCart)', original_selector);
                e.preventDefault();
                var $drawer = $('#sidebar-cart.Drawer[aria-hidden="true"]');
                openCartDrawer($drawer);
            });
            $(document).on("click", selectors.closeCart, function(e) {
                e.preventDefault();
                // $(selectors.openCart).attr('aria-expanded', false);
                var $drawer = $("#" + $(this).attr("data-drawer-id"));
                var $overlay = $(".PageOverlay");
                closeCartDrawer($drawer, $overlay);
            });
            $(document).on("click", ".PageOverlay.Is-visible", function() {
                var $drawer = $('.Drawer[aria-hidden="false"]');
                if ($("body").hasClass("Open--Menu")) $("body").removeClass("Open--Menu");
                // $(selectors.openCart).attr('aria-expanded', false);
                closeCartDrawer($drawer, $(this));
            });
            $(document).on("click change", selectors.qty, function(e) {
                if (e.type === "keyup" && e.keyCode !== 13) return;
                e.preventDefault();
                var el = $(this), qtySelector = el.siblings(".js-qty__num"), qty = parseInt(qtySelector.val().replace(/\D/g, ""));
                // Make sure we have a valid integer
                if (!(parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) qty = 1;
                // Add or subtract from the current quantity
                if (el.hasClass("js-qty__adjust--plus")) // qty = qty + 1;
                qty = qty >= el.data("quantity") ? qty : qty + 1;
                else {
                    qty = qty - 1;
                    if (qty <= 1) qty = 1;
                }
                // Update the input's number
                qtySelector.val(qty).trigger("change");
                if (!$(".PDPSubscription__OptionLabel").length) // Update the price
                calculationPrice();
            });
            function calculationPrice() {
                var productPriceVal = $(selectors.productPrice).data("product-price"), qty = $(selectors.productQuantityInput).val(), productPriceForChange = $(selectors.containersWithPrice).find(selectors.productPrice), priceFoSet = parseInt(productPriceVal) * parseInt(qty), comparePrice = $(selectors.containersWithPrice).find(selectors.comparePrice);
                $(productPriceForChange).html(slate.Currency.formatMoney(priceFoSet, theme.moneyFormat));
                if (comparePrice.length) {
                    var comparePriceVal = $(selectors.comparePrice).data("compare-price-update-price"), comparePriceForChange = $(selectors.containersWithPrice).find(selectors.comparePrice), comparePriceFoSet = parseInt(comparePriceVal) * parseInt(qty);
                    $(comparePriceForChange).html(slate.Currency.formatMoney(comparePriceFoSet, theme.moneyFormat));
                }
            }
            $("body").on(":calculationPrice", function(e) {
                calculationPrice();
            });
            // All quantity input value change on up/down arrows key press
            $(".js-qty__num").on("keyup", function(e) {
                // On arrow up key press (38)
                if (e.keyCode == 38) $(this).siblings(".js-qty__adjust--plus").trigger("click");
                // On arrow down key press (40)
                if (e.keyCode == 40) $(this).siblings(".js-qty__adjust--minus").trigger("click");
            });
            $(document).on("change keyup", selectors.selectorQuantity, function() {
                var _self = $(this);
                var quantity = parseInt($(this).attr("data-quantity"));
                var val = parseInt($(this).val());
                var elPlus = _self.siblings(".js-qty__adjust--plus");
                if (val >= quantity) {
                    _self.val(quantity);
                    elPlus.addClass("Disabled");
                } else elPlus.removeClass("Disabled");
            });
            $(document).on("change", selectors.variantSelect, function(e) {
                var _self = $(this);
                var val = _self.val();
                var quantity = parseInt(_self.find('[data-value="' + val + '"]').attr("data-quantity"));
                var input = _self.parents(".CartItem__Actions").find(".QuantitySelector__Quantity");
                var elPlus = _self.parents(".CartItem__Actions").find(".js-qty__adjust--plus");
                var btn = _self.parents(".CartItem__Info").find("[data-quick-add]");
                input.attr("data-quantity", quantity);
                btn.attr("data-variant-id", val);
                input.val(1);
                if (elPlus.hasClass("Disabled")) elPlus.removeClass("Disabled");
            });
            /* $(document).on('click', selectors.addToCart, function (e) {
        original_selector = $(this);
        console.log('original_selector (addToCart)', original_selector);
        });
            
            $(document).on('click', selectors.quickAdd, function (e) {
                e.preventDefault();

        original_selector = $(this);
        console.log('original_selector (quickAdd)', original_selector);
                
                var _self = $(this),
                        errorContainer = _self.siblings('[data-cart-error]'),
                        variant = $(this).attr('data-variant-id'),
                        productQuantity = $(this).parents('.CartItem__Info').find('.quantity__input').val(),
                        $drawer = $('#quick-view.Drawer'),
                        products_data = [],
                        products = [],
                        message = theme.strings.addToCart;

                if (productQuantity == '' || productQuantity == false || productQuantity == undefined) {
                    productQuantity = 1;
                }
                
                //for bundle product
                if (this.hasAttribute('data-add-bundle-product')) {
                    var $shades = _self.siblings('[data-select-available]').find('[data-option-available]'),
                            _main_bundle_name = _self.parent().find('#_main_bundle_name').val(),
                            _main_bundle_link = _self.parent().find('#_main_bundle_link').val(),
                            _main_bundle_sku = _self.parent().find('#_main_bundle_sku').val();
                            errorContainer = _self.siblings('[data-cart-error]');
                            message = theme.strings.addToBundle;

                    $shades.each(function () {
                        var variant_id = $(this).val();
                        products.push(variant_id);
                    });

                    products.forEach(function (item, index) {

                        products_data.push({
                            quantity: productQuantity,
                            id: item,
                            properties: { _bundle_index: index, _main_bundle_name, _main_bundle_link, _main_bundle_sku}
                        })
                    })
                    
                    // products.sort();
                    //
                    // products_data = []
                    // var current = null;
                    // var cnt = 0;
                    //
                    // for (var i = 0; i < products.length; i++) {
                    // 	if (products[i] != current) {
                    // 		if (cnt > 0) {
                    // 			products_data.push({
                    // 				quantity: cnt,
                    // 				id: current,
                    // 				properties: {_bundle_index: i, _main_bundle_name, _main_bundle_link, _main_bundle_sku}
                    // 			})
                    //
                    // 			console.log(3)
                    // 		}
                    // 		current = products[i];
                    // 		cnt = 1;
                    //
                    // 		console.log(2)
                    // 	} else {
                    // 		cnt++;
                    //
                    // 		console.log(1)
                    // 	}
                    // }
                    //
                    // if (cnt > 0) {
                    // 	products_data.push({
                    // 		quantity: cnt,
                    // 		id: current,
                    // 		properties: {_main_bundle_name, _main_bundle_link, _main_bundle_sku}
                    // 	})
                    //
                    // 	console.log(4)
                    // }

                } else {
            let _subscriptio_plan_name = "noSubscription"
                    products_data.push({
                        quantity: productQuantity,
                        id: variant,
            properties: { _subscriptio_plan_name }
                    });
                }


                $.ajax({
                    url: '/cart/add.js',
                    cache: false,
                    type: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                    },
                    data: JSON.stringify({items: products_data}),
                    dataType: 'json',
                    success: function () {
                        if ($drawer.attr('aria-hidden') === 'false') {
                            $drawer.attr('aria-hidden', 'true')
                        }
                        
                        setTimeout(function () {
                            _self.html(theme.strings.adding);
                        }, 300)
                        
                        setTimeout(function () {
                            renderCart();
                        }, 1000)
                        
                        setTimeout(function () {
                        _self.html(message);
                        }, 1300)
                    },
                    error: function (error) {
                        if (error.status === 422 && errorContainer.length) {
                            errorContainer.text(error.responseJSON.description);
                            errorContainer.slideDown();
                            
                            setTimeout(function () {
                                errorContainer.slideUp();
                            }, 10000)
                        }
                    }
                });
            }); */ function checkingHideShowBtn() {
                var windowHeight = $(window).height();
                var scrollHeight = $(".Drawer__RecomWrapper[data-scrollable] .Drawer__RecomWrapperInner").outerHeight();
                if (scrollHeight <= windowHeight) $(".Drawer__RecomFooterWrapper").slideUp();
                else $(".Drawer__RecomFooterWrapper").slideDown();
                $(".Drawer__RecomWrapper").on("scroll", function() {
                    if (Math.ceil($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight) $(".Drawer__RecomFooterWrapper").slideUp();
                    else $(".Drawer__RecomFooterWrapper").slideDown();
                });
            }
            $(window).on("resize orientationchange", function() {
                var windowHeight = $(window).height();
                var scrollHeight = $(".Drawer__RecomWrapper[data-scrollable] .Drawer__RecomWrapperInner").outerHeight();
                if ($(window).width() < 767) $(".Drawer__RecomFooterWrapper").css("display", "none");
                else if (scrollHeight >= windowHeight) $(".Drawer__RecomFooterWrapper").slideDown();
            });
            if (new URLSearchParams(location.search).has("cart")) {
                var urlParams = new URLSearchParams(location.search);
                urlParams.delete("cart");
                history.replaceState(null, null, location.href.replace(location.search, "?" + urlParams));
                $("body").trigger(":addToCart");
                original_selector = $("body");
                console.log("original_selector (url)", original_selector);
            }
            // ---- Tracking events
            function trackingEvents() {
                $(document).on("click", "[data-add-to-cart-ga]", function(e) {
                    ga("send", "event", "Cart Upsell", $(this).attr("data-add-to-cart-ga").replace(" Cart Upsell", ""));
                    dataLayer.push({
                        "event": $(this).attr("data-add-to-cart-ga")
                    });
                });
            }
            checkForRemainder();
            checkingHideShowBtn();
            trackingEvents();
            //disableQuantityButtons();
            // Set a trap for KB users (accessibility)
            $("#sidebar-cart").on("keydown", function(e) {
                if ($(e.target).hasClass("first-focusable-element") && e.key == "Tab" && e.shiftKey) {
                    e.preventDefault();
                    setTimeout(function() {
                        $(".last-focusable-element").get(0).focus();
                    });
                } else if ($(e.target).hasClass("last-focusable-element") && e.key == "Tab" && !e.shiftKey) {
                    e.preventDefault();
                    setTimeout(function() {
                        $(".first-focusable-element").get(0).focus();
                    });
                }
            });
            // Intelligems Handling
            function handleIntelligems() {
                const igData = window.igData;
                if (typeof igData !== "undefined") {
                    if (typeof igData?.user?.getExperiments()[0]?.id === "undefined") console.log("IG (Cart) - No experiments.");
                    else {
                        console.log("IG (Cart) - Found experiments.");
                        // Check for subscriptions
                        let subsExist = document.querySelector("[data-fs-subs-exist]");
                        // Use IG threshold only if no subscriptions in cart
                        if (subsExist == null) {
                            console.log("IG (Cart) - No subscriptions.");
                            $("[data-fs-message]").hide();
                            $("[data-fs-ig-remaining-message]").show();
                            $("[data-fs-amount-message]").hide();
                            $("[data-fs-ig-amount-message]").show();
                            let experimentId = igData.user.getExperiments()[0].id;
                            let testGroup = igData.user.getTestGroup(experimentId);
                            let fsThreshold = String(testGroup.freeShippingThreshold).replace(/^\D+/g, "") * 100;
                            console.log(`IG (Cart) - Free shipping threshold: ${fsThreshold}`);
                            // Get subtotal amount
                            let subtotalElement = document.querySelector(".Drawer__FooterInfoSubtotalPrice");
                            let subtotal;
                            if (subtotalElement == null) subtotal = 0;
                            else subtotal = subtotalElement.textContent.replace(/^\D+/g, "") * 100;
                            // Calc percentages and remaining
                            let pctThreshold = fsThreshold * 0.1;
                            let awayFromFS = Math.round(Math.min(Math.max(subtotal / pctThreshold * 0.1, 0), 1) * 100);
                            let remaining = fsThreshold - subtotal;
                            console.log(`IG (Cart) - subtotal: ${subtotal}`);
                            console.log(`IG (Cart) - awayFromFS: ${awayFromFS}%`);
                            console.log(`IG (Cart) - remaining: ${remaining}`);
                            $("[data-fs-remaining]").text(`$${(remaining * 0.01).toFixed(2)}`);
                            $("[data-fs-amount]").text(`$${fsThreshold * 0.01}`);
                            $("[data-fs-progress-line]").css("width", `${awayFromFS}%`);
                            $("[data-fs-progress-icon]").css("width", `${awayFromFS}%`);
                            if (remaining <= 0) {
                                $("[data-fs-ig-remaining-message]").hide();
                                $("[data-fs-ig-amount-message]").hide();
                                $("[data-fs-ig-earned-message]").show();
                            } else {
                                $("[data-fs-ig-earned-message]").hide();
                                $("[data-fs-ig-remaining-message]").show();
                                $("[data-fs-ig-amount-message]").show();
                            }
                        } else console.log("IG (Cart) - Found subscription(s).");
                    }
                } else console.log("IG - Not found.");
            }
            handleIntelligems();
        }
        return cartDrawer;
    }
};
var $1c739f26630ae9d4$export$2e2bcd8739ae039 = $1c739f26630ae9d4$var$cart_drawer;


const $47900ec3d6a9aaae$var$collections = {
    init: ()=>{
        var selectors = {
            collectionsContainer: ".CollectionProductsContainer",
            subheaderLink: ".Subheader__Link",
            productCard: ".ProductCardWrapper"
        };
        //prevent fast clicking (Scroll execution queue)
        // let preventMultipleScroll = false;
        $(selectors.collectionsContainer).find(selectors.subheaderLink).on("click", (e)=>{
            e.preventDefault();
            const target = e.target, trigger = $(target).attr("data-trigger"), headerHeight = $(".Header").height() + $(".Subheader").height();
            $([
                document.documentElement,
                document.body
            ]).animate({
                scrollTop: $(`[data-target-subheader="${trigger}"]`).offset().top - headerHeight
            }, 250);
        });
        var productCard = $(".ProductCardWrapper");
        productCard.on("mouseenter", function(e) {
            $(".ProductCardWrapper[data-active-product]").removeClass("Active");
        });
        productCard.on("mouseleave", function(e) {
            $(".CollectionProducts__Wrapper").each(function() {
                $(this).find(".ProductCardWrapper[data-active-product]").addClass("Active");
            });
        });
        $(selectors.collectionsContainer).find("[data-quick-view]").on("click", function() {
            ga("send", "event", "Ecommerce", "PLP Quick View");
        });
        $(selectors.collectionsContainer).find("[data-quick-add]").on("click", function() {
            ga("send", "event", "Ecommerce", "PLP Add");
        });
    }
};
var $47900ec3d6a9aaae$export$2e2bcd8739ae039 = $47900ec3d6a9aaae$var$collections;


const $b806f99d4ff2dc2b$var$contact_us = {
    init: ()=>{
        accordionHeaders = document.querySelectorAll(".ContactUs__ListItemQuestion button");
        accordionHeaders.forEach(function(header) {
            header.addEventListener("click", function() {
                var isExpanded = header.getAttribute("aria-expanded") == "true" ? true : false;
                header.setAttribute("aria-expanded", !isExpanded);
                $("#" + header.getAttribute("aria-controls")).slideToggle();
            });
        });
    /* $('.ContactUs__ListItemQuestion').on('click', function () {
            var _self = $(this)

            _self.next().slideToggle();
            _self.find('.PlusIcon').toggleClass('PlusIcon--Active')
        }); */ }
};
var $b806f99d4ff2dc2b$export$2e2bcd8739ae039 = $b806f99d4ff2dc2b$var$contact_us;


const $70695669e66c53d4$var$faq = {
    init: ()=>{
        var $btnScrollToTop = $(".FAQ__BtnScrollToTop");
        $(".FAQ__ContentListQuestion").on("click", function() {
            var _self = $(this);
            _self.next().slideToggle();
            _self.find(".PlusIcon").toggleClass("PlusIcon--Active");
        });
        $(window).on("scroll resize orientationchange", function() {
            var _self = $(this);
            if (_self.scrollTop() > 300 && _self.width() > 767) $btnScrollToTop.attr("aria-hidden", false);
            else $btnScrollToTop.attr("aria-hidden", true);
        });
        $btnScrollToTop.on("click", function() {
            $("html,body").animate({
                scrollTop: 0
            }, 1000);
        });
    }
};
var $70695669e66c53d4$export$2e2bcd8739ae039 = $70695669e66c53d4$var$faq;


const $c0544ef036311d51$var$featured_products = {
    init: ()=>{
        const featuredProductsEls = document.querySelectorAll(`.FeaturedProducts`);
        featuredProductsEls.forEach((container)=>{
            var $sliderMain = $(container).find(".FeaturedProducts__Content");
            var $sliderThumbnails = $(container).find(".FeaturedProducts__Thumbnails");
            var configMain = $.parseJSON($sliderMain.attr("data-slick-config"));
            var configThumbnails = $.parseJSON($sliderThumbnails.attr("data-slick-config"));
            // Accessibility
            /*
            $sliderThumbnails.on('init', function() {
                console.log('slider lives!');
                $sliderThumbnails.on('afterChange', function() {
                    console.log('slider changed!');
                    let $current = $('.FeaturedProducts__Thumbnail.slick-current');
                    $sliderThumbnails.closest('.FeaturedProducts__Thumbnails').attr('aria-labelledby', $current.attr('id'));
                    $('.FeaturedProducts__Thumbnail').each(function() {
                        $(this).attr('aria-selected', false).attr('tabindex', '-1');
                    });
                    $current.attr('aria-selected', true).attr('tabindex', '0');
                });
            });
            */ $(document).on("shopify:section:select", function(e) {
                $sliderMain.slick("unslick");
                $sliderMain.find(".slick-slide").remove();
                $sliderMain = $(".FeaturedProducts__Content");
                $sliderMain.slick(configMain);
                $sliderThumbnails.slick("unslick");
                $sliderThumbnails.find(".slick-slide").remove();
                $sliderThumbnails = $(".FeaturedProducts__Thumbnails");
                $sliderThumbnails.slick(configThumbnails);
            });
            // Accessibility
            $(".FeaturedProducts__Thumbnail").on("keydown", function(e) {
                if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) updateSlides(this);
            });
            $(".FeaturedProducts__Thumbnail").on("click", function() {
                updateSlides(this);
            });
            function updateSlides(element) {
                setTimeout(function() {
                    // $('.FeaturedProducts__Thumbnail').each(function() {
                    //     $(this).attr('aria-selected', false).attr('tabindex', '-1');
                    // });
                    // let $current = $('.FeaturedProducts__Thumbnail.slick-current');
                    // $current.attr('aria-selected', true).attr('tabindex', '0');
                    $(element).closest(".FeaturedProducts__Thumbnails").attr("aria-labelledby", $current.attr("id"));
                }, 200);
            }
        });
    }
};
var $c0544ef036311d51$export$2e2bcd8739ae039 = $c0544ef036311d51$var$featured_products;


const $e4945ec127c41669$var$header = {
    init: ()=>{
        // TODO:
        // Previously this was provided by Slate
        // It would get the exact section container, id, etc.
        // Basically just scopes this code
        // Needs to be replaced with equivalent functionality
        let container = "body";
        $(".Header__RegionSelect").on("change", function() {
            const url_usa = "shop.momofuku.com", url_can = "canadashop.momofuku.com";
            let region = $(this).val(), current_url = window.location, new_url = new URL(current_url);
            console.log(`Region changed! region: ${region}, current_url: ${current_url}`);
            if (region === "can") {
                new_url.hostname = url_can;
                console.log(`new_url.href: ${new_url.href}`);
            } else {
                new_url.hostname = url_usa;
                console.log(`new_url.href: ${new_url.href}`);
            }
            window.location.href = new_url.href;
        });
        var $container = $(container);
        var $header = $container.find(".Header");
        var $icon = $(container).find(".Header__IconBurger");
        var $mobileMenu = $(".Header__NavigationMobile");
        var $pageOverlay = $(".PageOverlay");
        var $removeOpenMenu = $("[data-remove-open]");
        var $subheader = $(".Subheader");
        var $desktopMenu = $container.find(".Header__Navigation");
        var $megaBlocks = $desktopMenu.find(".Header__HoverBlock");
        $megaBlocks.each(function() {
            $(this).parent().addClass("has-block");
        });
        var mouseOutTimer;
        var mouseOutHideDelay = 1000;
        var menuVisible = false;
        $desktopMenu.find(".has-block").each(function() {
            var $navLink = $(this);
            var $navToggleButton = $navLink.find(".nav-toggle-button");
            $navLink.on("mouseover", function() {
                showMenu($navLink);
                clearTimeout(mouseOutTimer);
            });
            $navLink.on("mouseout", function() {
                mouseOutTimer = setTimeout(function() {
                    hideMenu($navLink);
                }, mouseOutHideDelay);
            });
            $navLink.on("keydown", function(e) {
                var lastMenuItem = $navLink.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').last()[0];
                if (e.key === "Tab" && !e.shiftKey && e.target === lastMenuItem || e.key == "Escape") hideMenu($navLink);
                if (e.key == "Escape") $navToggleButton.focus();
            });
            $navToggleButton.on("click", function() {
                toggleMenu($navLink);
            });
        });
        function showMenu($navLink) {
            $navLink.find(".nav-toggle-button").attr("aria-expanded", true);
            $navLink.find(".Header__HoverBlock").attr("aria-hidden", false);
            $navLink.siblings().find(".nav-toggle-button").attr("aria-expanded", false);
            $navLink.siblings().find(".Header__HoverBlock").attr("aria-hidden", true);
            menuVisible = true;
            gtag("event", "show_mega_menu", {
                "parent_menu": `${$navLink.find(".Header__NavigationLink--Style")[0]?.innerHTML}`
            });
        }
        function hideMenu($navLink) {
            $navLink.find(".nav-toggle-button").attr("aria-expanded", false);
            $navLink.find(".Header__HoverBlock").attr("aria-hidden", true);
            menuVisible = false;
            gtag("event", "hide_mega_menu", {
                "parent_menu": `${$navLink.find(".Header__NavigationLink--Style")[0]?.innerHTML}`
            });
        }
        function toggleMenu($navLink) {
            if (menuVisible) hideMenu($navLink);
            else showMenu($navLink);
        }
        //----Sticky header
        // $(window).scroll(function () {
        //   if ($(this).scrollTop() > 70) {
        //     $header.addClass("Sticky");
        //     $subheader.addClass("Subheader--Sticky");
        //   } else {
        //     $header.removeClass("Sticky");
        //     $subheader.removeClass("Subheader--Sticky");
        //   }
        // });
        // test
        //----Mobile Mega Menu
        $(".Header__NavigationLinkMobile").on("click", function() {
            let $megaBlock = $(this).find(".Header__OpenBlock");
            let $megaToggle = $(this).find(".Header__NavigationLinkMobile--Toggle");
            if ($megaBlock.hasClass("Block--Open")) {
                $(this).removeClass("Link--Open");
                $megaBlock.removeClass("Block--Open");
                $megaToggle.html(`
                <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="none"/>
                <path d="M17 9.5L12 14.5L7 9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              `);
            } else {
                closeAll();
                let scrollTop = $(this).offset().top;
                // console.log('$(this).offset.top:', $(this).offset().top)
                $(this).addClass("Link--Open");
                $megaBlock.addClass("Block--Open");
                $megaToggle.html(`
                <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" fill="none"/>
                <path d="M7 14.5L12 9.5L17 14.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>                
              `);
                let headerHeight = $(".Header").height();
                let scrollTarget = scrollTop - headerHeight;
                $(".Header__NavigationMobileWrapper").animate({
                    scrollTop: scrollTarget,
                    easing: "swing"
                }, 500);
            }
        });
        function closeAll() {
            $(".Header__NavigationLinkMobile").removeClass("Link--Open");
            $(".Header__OpenBlock").removeClass("Block--Open");
            $(".Header__NavigationLinkMobile--Toggle").html(`
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none">
          <rect width="24" height="24" fill="none"/>
          <path d="M17 9.5L12 14.5L7 9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `);
        }
        let isHandleKeydownEventSet = false;
        const trapFocus = (container, lastFocused)=>{
            if (!container) return;
            const elements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            let focusableContent = container.querySelectorAll(elements);
            let firstFocusableElement = focusableContent[0];
            let lastFocusableElement = focusableContent[focusableContent.length - 1];
            const handleKeydown = (e)=>{
                /**
             * Because of the dynamic content inside the modal,
             * we are rewriting cached elements on every tab click
             */ focusableContent = container.querySelectorAll(elements);
                firstFocusableElement = focusableContent[0];
                lastFocusableElement = focusableContent[focusableContent.length - 1];
                if (e.key !== "Tab") return;
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement?.focus();
                        e.preventDefault();
                    }
                } else if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement?.focus();
                    e.preventDefault();
                }
            };
            if (lastFocused) lastFocused.focus();
            else {
                if (!isHandleKeydownEventSet) {
                    document.addEventListener("keydown", handleKeydown);
                    isHandleKeydownEventSet = true;
                }
                firstFocusableElement?.focus();
            }
        };
        //----Animation burger icon and open menu
        let lastFocusedElement = document.activeElement;
        const currentDrawer = document.querySelector(".MobileNavigation");
        const currentDrawerElements = currentDrawer.querySelectorAll("button, a");
        const firstDrawerElement = currentDrawerElements[0];
        currentDrawerElements.forEach((el)=>{
            el.setAttribute("tabindex", "-1");
        });
        $icon.on("click", function(e) {
            $("body").toggleClass("Open--Menu");
            $pageOverlay.toggleClass("Is-visible");
            if ($("body").hasClass("Open--Menu")) {
                $mobileMenu.attr("aria-hidden", "false");
                currentDrawerElements.forEach((el)=>{
                    el.setAttribute("tabindex", "0");
                });
                trapFocus(currentDrawer);
                firstDrawerElement.focus();
            } else {
                $mobileMenu.attr("aria-hidden", "true");
                trapFocus(currentDrawer, lastFocusedElement);
                currentDrawerElements.forEach((el)=>{
                    el.setAttribute("tabindex", "-1");
                });
            }
        });
        // Escape key closes the menu
        $(document).on("keydown", function(e) {
            if (e.key === "Escape" && $("body").hasClass("Open--Menu")) {
                $("body").removeClass("Open--Menu");
                $pageOverlay.removeClass("Is-visible");
                $mobileMenu.attr("aria-hidden", "true");
                trapFocus(currentDrawer, lastFocusedElement);
                currentDrawerElements.forEach((el)=>{
                    el.setAttribute("tabindex", "-1");
                });
            }
        });
        // ----For close menu when push on browser btn back on mobile
        $removeOpenMenu.on("click", function(e) {
            $("body").removeClass("Open--Menu");
            $pageOverlay.removeClass("Is-visible");
            bodyScrollLock.clearAllBodyScrollLocks();
        });
        $(window).on("resize", function() {
            if ($(window).width() > 990) $("body").removeClass("Open--Menu");
        });
        var $buttonToggle = $(container).find('[data-action="toggle-collapsible"]');
        $buttonToggle.on("click", function(e) {
            e.preventDefault();
            var _$self = $(this);
            var isOpen = _$self.attr("aria-expanded") === "true";
            if (isOpen) _$self.attr("aria-expanded", false).next().slideUp();
            else _$self.attr("aria-expanded", true).next().slideDown();
        });
    }
};
var $e4945ec127c41669$export$2e2bcd8739ae039 = $e4945ec127c41669$var$header;


const $22826d8d58b054d6$var$newsletter = {
    init: ()=>{
        // TODO:
        // Previously this was provided by Slate
        // It would get the exact section container, id, etc.
        // Basically just scopes this code
        // Needs to be replaced with equivalent functionality
        let container = '[data-section-type="newsletter"]';
        var $container = $(container);
        if ($container.length > 0) {
            var $newsletterInput = $container.find(".Newsletter__Input");
            var $newsletterInputWrapper = $container.find(".Newsletter__InputContainer");
            var klaviyoListId = $container.data("list-id");
            var $btn = $container.find(".Newsletter__InputSubmit");
            var $errorNotValidEmail = $container.find(".Error--NotValidEmail");
            var $form__subscription = $container.find("#prefooter-form__subscription");
            var $form__error = $container.find("#prefooter-form__error");
            var $form__first_subscription = $container.find("#prefooter-form__first-subscription");
            $newsletterInput.on("focus", function() {
                let input_id = $newsletterInput.attr("id");
                $(`label[for=${input_id}]`).addClass("js-is-active");
            });
            $newsletterInput.on("change keyup", function() {
                var _self = $(this);
                var email = _self.val();
                function validateEmail(email) {
                    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(email);
                }
                var chackingValidEmail = validateEmail(email);
                if (!chackingValidEmail) {
                    $btn.attr("disabled", true).addClass("disabled");
                    //$newsletterInput.attr('aria-invalid', true); // Not needed, accessibility is covered in other ways
                    $newsletterInput.attr("aria-describedby", "prefooter-form__not-valid");
                    $errorNotValidEmail.slideDown();
                    $form__subscription.hide();
                    $form__error.hide();
                    $form__first_subscription.hide();
                } else {
                    $btn.attr("disabled", false).removeClass("disabled");
                    $newsletterInput.removeAttr("aria-invalid");
                    $newsletterInput.removeAttr("aria-describedby");
                    $errorNotValidEmail.slideUp();
                    $form__subscription.hide();
                    $form__error.hide();
                    $form__first_subscription.hide();
                }
            });
            $btn.on("click", function(e) {
                e.preventDefault();
                var email = $container.find(".Newsletter__Input").val();
                var origin = "";
                var data = {
                    "g": klaviyoListId,
                    "$fields": "$source,$email,$consent_method,$consent_form_id,$origin",
                    "$list_fields": "",
                    "$timezone_offset": Math.abs(new Date().getTimezoneOffset() / 60),
                    "$source": "Newsletter subscription",
                    "$email": email,
                    "$consent_method": "Klaviyo Form",
                    "$origin": origin
                };
                $.ajax({
                    method: "POST",
                    url: "https://a.klaviyo.com/ajax/subscriptions/subscribe",
                    data: data
                }).done(function(response) {
                    console.log(klaviyoListId, response, $container);
                    if (response.success) {
                        if (response.data.is_subscribed) {
                            $form__subscription.hide();
                            $form__error.hide();
                            $form__first_subscription.slideDown();
                            $newsletterInput.attr("aria-describedby", "prefooter-form__first-subscription");
                            $newsletterInput.focus();
                        } else if (!response.data.is_subscribed) {
                            $form__first_subscription.hide();
                            $form__error.hide();
                            $form__subscription.slideDown();
                            $newsletterInput.attr("aria-describedby", "prefooter-form__subscription");
                            $newsletterInput.focus();
                        }
                    } else {
                        $form__first_subscription.hide();
                        $form__subscription.hide();
                        $container.find(".Newsletter__Input").val("");
                        $form__error.slideDown();
                        $newsletterInput.attr("aria-describedby", "prefooter-form__error");
                        $newsletterInput.focus();
                    }
                }).fail(function(err) {
                    $form__first_subscription.hide();
                    $form__subscription.hide();
                    $container.find(".Newsletter__Input").val("");
                    $form__error.slideDown();
                    $newsletterInput.attr("aria-describedby", "prefooter-form__error");
                    $newsletterInput.focus();
                });
            });
        //----------------------------
        // $btn.on("click", function(e) {
        //   e.preventDefault();
        //
        //   console.log(listId)
        //
        //   var cusemail = $container.find('.Newsletter__Input').val();
        //   console.log('Newsletter__Input')
        //   var settings = {
        //     "async": true,
        //     "crossDomain": true,
        //     "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        //     "method": "POST",
        //     "headers": {
        //       "content-type": "application/x-www-form-urlencoded",
        //       "cache-control": "no-cache"
        //     },
        //     "data": {
        //       "g": listId,
        //       "email": cusemail,
        //       "$source": "Newsletter form"
        //     }
        //   }
        //
        //   $.ajax(settings).done(function(response) {
        //     $newsletterInputWrapper.css('opacity', '0');
        //     console.log("done")
        //
        //     if (response.data.is_subscribed) {
        //       $success.slideDown();
        //       console.log("response.data.is_subscribed")
        //     } else {
        //       $error.slideUp();
        //       console.log("errors")
        //     }
        //   });
        // })
        }
    }
};
var $22826d8d58b054d6$export$2e2bcd8739ae039 = $22826d8d58b054d6$var$newsletter;


const $bbd06ce61d639104$var$password = {
    init: ()=>{
        const $passwordLink = $(".password__link");
        $passwordLink.on("click", function() {
            $(this).parent().next().show();
            $(this).hide();
        });
        // The trick to viewport units on mobile
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
};
var $bbd06ce61d639104$export$2e2bcd8739ae039 = $bbd06ce61d639104$var$password;


const $d02c32fe3290f392$var$product_out_of_stock = {
    init: ()=>{
        // TODO:
        // Previously this was provided by Slate
        // It would get the exact section container, id, etc.
        // Basically just scopes this code
        // Needs to be replaced with equivalent functionality
        let container = ".Product__OutOfStock";
        var $container = $(container);
        var klaviyoListId = $container.data("list-id");
        var $inputEmail = $container.find(".Product__OutOfStockInput");
        var $btn = $container.find("[data-product-out-of-stock]");
        var $errorNotValidEmail = $container.find(".Error--NotValidEmail");
        var $formSubscription = $container.find("#prefooter-form__subscription");
        var $formError = $container.find("#prefooter-form__error");
        var $formFirstSubscription = $container.find("#prefooter-form__first-subscription");
        var $formEnterEmail = $container.find("#prefooter-form__enter-email");
        $inputEmail.on("change keyup", function() {
            var _self = $(this);
            var email = _self.val();
            function validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }
            var chackingValidEmail = validateEmail(email);
            if (!chackingValidEmail) {
                $btn.attr("disabled", true).addClass("disabled");
                $errorNotValidEmail.slideDown();
                $formSubscription.hide();
                $formError.hide();
                $formFirstSubscription.hide();
                $formEnterEmail.slideUp();
            } else {
                $btn.attr("disabled", false).removeClass("disabled");
                $errorNotValidEmail.slideUp();
                $formSubscription.hide();
                $formError.hide();
                $formFirstSubscription.hide();
                $formEnterEmail.slideUp();
            }
        });
        $btn.on("click", function(e) {
            e.preventDefault();
            var email = $inputEmail.val();
            var origin = "";
            var data = {
                "g": klaviyoListId,
                "$fields": "$source,$email,$consent_method,$consent_form_id,$origin",
                "$list_fields": "",
                "$timezone_offset": Math.abs(new Date().getTimezoneOffset() / 60),
                "$source": "Chili Crunch - Notify Me!",
                "$email": email,
                "$consent_method": "Klaviyo Form",
                "$origin": origin
            };
            if (email.length == 0) $formEnterEmail.slideDown();
            if (email.length > 0) $.ajax({
                method: "POST",
                url: "https://a.klaviyo.com/ajax/subscriptions/subscribe",
                data: data
            }).done(function(response) {
                console.log(response);
                if (response.success) {
                    if (response.data.is_subscribed) {
                        $formSubscription.hide();
                        $formError.hide();
                        $formEnterEmail.slideUp();
                        $inputEmail.slideUp();
                        $btn.slideUp();
                        setTimeout(function() {
                            $formFirstSubscription.slideDown();
                        }, 1200);
                    } else if (!response.data.is_subscribed) {
                        $formFirstSubscription.hide();
                        $formError.hide();
                        $formEnterEmail.slideUp();
                        $inputEmail.slideUp();
                        $btn.slideUp();
                        setTimeout(function() {
                            $formSubscription.slideDown();
                        }, 1200);
                    }
                } else {
                    $formFirstSubscription.hide();
                    $formSubscription.hide();
                    $container.find(".Newsletter__Input").val("");
                    $formEnterEmail.slideUp();
                    $inputEmail.slideUp();
                    setTimeout(function() {
                        $formError.slideDown();
                    }, 1200);
                }
            }).fail(function(err) {
                $formFirstSubscription.hide();
                $formSubscription.hide();
                $container.find(".Newsletter__Input").val("");
                $formEnterEmail.slideUp();
                $inputEmail.slideUp();
                $formError.slideDown();
            });
        });
    }
};
var $d02c32fe3290f392$export$2e2bcd8739ae039 = $d02c32fe3290f392$var$product_out_of_stock;


const $4f9c27bad1a1736f$var$product_simple = {
    init: ()=>{
        $(document).ready(function() {
            if ($(".selection").length > 0) {
                $(".selection.js-selected").each(function() {
                    const $selected = $(this);
                    const currentVar = $selected.attr("data-combined-handle");
                    const $parent = $selected.closest(".Product__Simple");
                    const compare_price = $selected.data("variant-compare-price");
                    const price = $selected.data("variant-price");
                    $parent.find(".ProductPrice span[data-compare-price]").remove();
                    if (compare_price > price) {
                        var compare_price_fixed = (compare_price / 100).toFixed(2);
                        var $compare = $(`<span data-compare-price="" data-compare-price-update-price="${compare_price}" class="Price--compareAt">$${compare_price_fixed}</span>`);
                        $compare.appendTo($parent.find(`.ProductPrice`));
                        $($parent.find(`.rtx_option_one_time .rtx_option_price .price-comp`)).text(`$${compare_price_fixed}`);
                    } else $($parent.find(`.rtx_option_one_time .rtx_option_price .price-comp`)).text("");
                    $($parent.find(`.Product__HeroSliderWrapper, .Product__HeroDots, .Product__SliderNavDotsItem[data-combined-handle]`)).addClass("init-hide");
                    $($parent.find(`.Product__CartFormContainer option`)).removeAttr("selected");
                    $($parent.find(`.Product__CartFormContainer option[data-handle=${currentVar}]`)).attr("selected", "selected");
                    $($parent.find(`.Product__Description`)).hide();
                    $($parent.find(`.Product__Description[data-combined-handle=${currentVar}]`)).show();
                    $($parent.find(`.Product__HeroSliderWrapper[data-combined-handle=${currentVar}], .Product__HeroDots[data-combined-handle=${currentVar}], .Product__SliderNavDotsItem[data-combined-handle=${currentVar}]`)).removeClass("init-hide");
                    $($parent.find(`.Product__Servings`)).hide();
                    if ($(window).width() > 767) $($parent.find(`.Product__Servings[data-combined-handle=${currentVar}]`)).show();
                    $($parent.find(`.Product__HeroSliderWrapper, .Product__HeroDots`)).slick("resize");
                    // $($parent.find(`.Product__HeroSliderWrapper, .Product__HeroDots`)).slick('reinit');
                    $($parent.find(`.Product__HeroSliderWrapper[data-combined-handle=${currentVar}]`)).slick("reinit");
                });
                updateDotIndexes();
            }
        });
        // Accessibility
        function updateDotIndexes() {
            setTimeout(()=>{
                $(`.Product__HeroDots:visible.slick-initialized .Product__HeroDotsItem`).each(function() {
                    //console.log($(this).hasClass('slick-active'));
                    if ($(this).hasClass("slick-active")) $(this).attr("tabindex", 0);
                    else $(this).attr("tabindex", -1);
                });
            }, 200);
        }
        updateDotIndexes();
        $(`.Product__HeroDots .Product__HeroDotsItem, .Product__SliderNavArrow`).on("click", function() {
            updateDotIndexes();
        });
        $(".Product__Simple").each(function() {
            let parent = "";
            let test_data = $(this).parent().data("product");
            if (typeof test_data != "undefined") parent = `.${$(this).parent().attr("class")}[data-product='${test_data}']`;
            // PDP Content Updating
            $(`${parent} .Product__Selector .selection`).on("click", function(e) {
                //console.log(`clicked: ${parent} .Product__Selector .selection`);
                // Update/Toggle 'js-selected'
                $(this).parent().children(".selection").each(function() {
                    $(this).removeClass("js-selected");
                });
                $(this).addClass("js-selected");
                // Update '#productSelect'
                let variant = $(this).data("variant-id");
                $(`${parent} #productSelect option[selected=selected]`).each(function() {
                    $(this).removeAttr("selected");
                });
                $(`${parent} #productSelect option[value=${variant}]`).attr("selected", "selected");
                $(`${parent} #productSelect`).trigger("change");
                // Update Product Title
                /*
                let title = $(this).data('variant-title');
                $('.Product__Heading').text(title);
                */ // Swap Gallery
                let handle = $(this).data("combined-handle");
                //console.log(`combined-handle: ${handle}`)
                $(`${parent} .ProductCard__Badges[data-combined-handle]`).hide();
                $(`${parent} .Product__HeroSliderWrapper[data-combined-handle]`).hide();
                $(`${parent} .Product__HeroDots[data-combined-handle]`).hide();
                $(`${parent} .Product__SliderNavDotsItem[data-combined-handle]`).hide();
                $(`${parent} .ProductCard__Badges[data-combined-handle="${handle}"]`).css("display", "flex");
                $(`${parent} .Product__HeroSliderWrapper[data-combined-handle="${handle}"]`).show();
                $(`${parent} .Product__SliderNavDotsItem[data-combined-handle="${handle}"]`).show();
                if ($(window).width() >= 768) $(`${parent} .Product__HeroDots[data-combined-handle="${handle}"]`).show();
                $(`${parent} .Product__HeroSliderWrapper[data-combined-handle="${handle}"]`).slick("resize");
                $(`${parent} .Product__HeroSliderWrapper[data-combined-handle="${handle}"]`).slick("reinit");
                if ($(`${parent} .selection`).length > 0) {
                    $(`${parent} .Product__Description`).hide();
                    $(`${parent} .Product__Description[data-combined-handle=${handle}]`).show();
                    $(`${parent} .Product__Servings`).hide();
                    if ($(window).width() > 767) $(`${parent} .Product__Servings[data-combined-handle=${handle}]`).show();
                }
                $(`${parent} .Product__HeroDots[data-combined-handle]`).slick("resize");
                $(`${parent} .Product__CartFormContainer option`).removeAttr("selected");
                $(`${parent} .Product__CartFormContainer option[data-handle=${handle}]`).attr("selected", "selected");
                updateDotIndexes();
                // Update Gallery Badges
                // These are the badges that appear over the gallery.
                let badge_1 = $(this).data("variant-badge-1");
                let badge_2 = $(this).data("variant-badge-2");
                if (badge_1.length > 0) {
                    $(`${parent} .Product__HeroBadges .hero-badge-1`).text(badge_1);
                    $(`${parent} .Product__HeroBadges .hero-badge-1`).show();
                } else $(`${parent} .Product__HeroBadges .hero-badge-1`).hide();
                if (badge_2.length > 0) {
                    $(`${parent} .Product__HeroBadges .hero-badge-2`).text(badge_2);
                    $(`${parent} .Product__HeroBadges .hero-badge-2`).show();
                } else $(`${parent} .Product__HeroBadges .hero-badge-2`).hide();
                // Update Subscription Badge
                // This badge appears over the subscription selector.
                let badge_sub = $(this).data("sub-badge");
                if (badge_sub.length > 0) {
                    $(`${parent} .rtx_option .pdp-badge`).text(badge_sub);
                    $(`${parent} .rtx_option .pdp-badge`).show();
                } else $(`${parent} .rtx_option .pdp-badge`).hide();
                // Update Prices
                let price = $(this).data("variant-price");
                let price_fixed = (price / 100).toFixed(2);
                //console.log(`otp price: ${price}, price_fixed: ${price_fixed} (product-simple)`);
                $(`${parent} .rtx_option_one_time .rtx_option_price .price`).text(`$${price_fixed}`);
                let sub_price = $(this).data("selling-plan-price");
                let sub_price_fixed = (sub_price / 100).toFixed(2);
                //console.log(`sub price: ${sub_price}, price_fixed: ${sub_price_fixed} (product-simple)`);
                $(`${parent} .rtx_option_sub .rtx_option_price`).text(`$${sub_price_fixed}`);
                if ($(`.rtx--active`).hasClass("rtx_option_sub")) {
                    // Sub
                    $(`${parent} .ProductPrice span[data-product-price]`).attr("data-product-price", sub_price);
                    $(`${parent} .ProductPrice span[data-product-price]`).text(`$${sub_price_fixed}`);
                } else {
                    // OTP
                    $(`${parent} .ProductPrice span[data-product-price]`).attr("data-product-price", price);
                    $(`${parent} .ProductPrice span[data-product-price]`).text(`$${price_fixed}`);
                }
                let compare_price = $(this).data("variant-compare-price");
                //console.log(`price: ${price}, compare_price: ${compare_price}`);
                $(`${parent} .ProductPrice span[data-compare-price]`).remove();
                if (compare_price > price) {
                    let compare_price_fixed = (compare_price / 100).toFixed(2);
                    let $compare = $(`<span data-compare-price="" data-compare-price-update-price="${compare_price}" class="Price--compareAt">$${compare_price_fixed}</span>`);
                    $compare.appendTo(`${parent} .ProductPrice`);
                    $(`${parent} .rtx_option_one_time .rtx_option_price .price-comp`).text(`$${compare_price_fixed}`);
                } else $(`${parent} .rtx_option_one_time .rtx_option_price .price-comp`).text("");
                $(`${parent} .SubLP__Price .ProductPrice span[data-compare-price]`).remove();
                let $sub_compare = $(`<span data-compare-price="" data-compare-price-update-price="${price}" class="Price--compareAt">$${price_fixed}</span>`);
                $sub_compare.appendTo(`${parent} .SubLP__Price .ProductPrice`);
                // Update RTXN Selection
                let product_id = $(`${parent} .selection.js-selected`).data("product-id");
                let variant_id = $(`${parent} .selection.js-selected`).data("variant-id");
                //let selling_plan_id = $('.selection.js-selected').data('selling-plan-id');
                if ($(`${parent} .rtx--active`).hasClass("rtx_option_sub")) $(`${parent} .rtx_option_plans`).show();
                else $(`${parent} .rtx_option_plans`).hide();
                $(`${parent} .PDPSubscription input[name="selling_plan"]`).attr("id", `selling_plan_${product_id}`);
                //$(`.PDPSubscription input[name="selling_plan"]`).val(selling_plan_id); // this breaks subs
                $(`${parent} .PDPSubscription input[name="id"]`).val(variant_id);
                $(`${parent} .rtx_buy_box`).attr("id", `rtx_buy_box_${product_id}`);
                $(`${parent} .rtx_buy_box`).attr("value", variant_id);
                $(`${parent} .rtx--active`).find(".rtx_option_radio").trigger("click");
            });
            // Subscription Toggles
            $(`${parent} .rtx_option`).on("click", function() {
                let otp_class = "rtx_option_one_time";
                let sub_class = "rtx_option_sub";
                if ($(this).hasClass(otp_class) && !$(this).hasClass("rtx--active")) {
                    let $radio = $(this).find(".rtx_option_radio");
                    //console.log(`otp radio: `, $radio);
                    $(`${parent} .${sub_class}`).removeClass("rtx--active");
                    $(`${parent} .${otp_class}`).addClass("rtx--active");
                    $radio.on("click", function(e) {
                        e.stopPropagation();
                    });
                    $radio.trigger("click");
                } else if ($(this).hasClass(sub_class) && !$(this).hasClass("rtx--active")) {
                    let $radio = $(this).find(".rtx_option_radio");
                    //console.log(`sub radio: `, $radio);
                    $(`${parent} .${otp_class}`).removeClass("rtx--active");
                    $(`${parent} .${sub_class}`).addClass("rtx--active");
                    $radio.on("click", function(e) {
                        e.stopPropagation();
                    });
                    $radio.trigger("click");
                }
            // Defunct
            // if ($(this).hasClass('selling-plan') && $(this).hasClass('js-selected')) {
            //   $('.StyledSelect__OptionsWrapper').attr('aria-hidden', 'false');
            //   $('.StyledSelect__OptionsWrapper').show();
            // } else {
            //   $('.StyledSelect__OptionsWrapper').attr('aria-hidden', 'true');
            //   $('.StyledSelect__OptionsWrapper').hide();
            // }
            });
        });
    }
};
var $4f9c27bad1a1736f$export$2e2bcd8739ae039 = $4f9c27bad1a1736f$var$product_simple;


const $7c5126ea5818fee1$var$product = {
    init: ()=>{
        var selectors = {
            addToCart: "[data-add-to-cart]",
            addBundle: "[data-add-bundle-product]",
            productQuantity: "[data-product-quantity]",
            addToCartText: "[data-add-to-cart-text]",
            comparePrice: "[data-compare-price]",
            comparePriceText: "[data-compare-text]",
            originalSelectorId: "[data-product-select]",
            priceWrapper: "[data-price-wrapper]",
            productFeaturedImage: "[data-product-featured-image]",
            productJson: "[data-product-json]",
            productPrice: "[data-product-price]",
            productThumbs: "[data-product-single-thumbnail]",
            singleOptionSelector: "[data-single-option-selector]",
            addToCartErrorContainer: "[data-cart-error]",
            addToCartErrorContainerSticky: "[data-cart-sticky]",
            addToCartErrorContainerHero: "[data-cart-hero]",
            form: '[action="/cart/add"]',
            dropdownBtn: "[data-accordion-btn]",
            dropdownContent: "[data-accordion-content]",
            productSelect: "[data-product-select]",
            productInput: "[data-product-quantity]",
            productQuantityInput: ".Product__QuantityInput",
            rechargeOptionInput: ".rtx_option_radio"
        };
        //spoilers
        $(selectors.dropdownBtn).click((e)=>{
            const target = e.target;
            if ($(target).hasClass("Product__DropdownBtn")) {
                $(target).children(".PlusIcon").toggleClass("PlusIcon--Active");
                slideToggle($(target).parent().find(selectors.dropdownContent), target);
            }
            function slideToggle($element, target) {
                if (!$element.length) {
                    var $elementContent = $(target).parents(".PDPSubscription").find(selectors.dropdownContent);
                    if ($elementContent.attr("aria-hidden") == "false") {
                        $elementContent.slideUp();
                        $(target).attr("aria-expanded", false);
                        $elementContent.attr("aria-hidden", true);
                    }
                } else if ($element.attr("aria-hidden") == "true") {
                    $element.slideDown();
                    $(target).attr("aria-expanded", true);
                    $element.attr("aria-hidden", false);
                } else {
                    $element.slideUp();
                    $(target).attr("aria-expanded", false);
                    $element.attr("aria-hidden", true);
                }
            }
        });
        //quantity
        const syncQuantity = ()=>{
            $(document).on("change", selectors.productInput, function(e) {
                $(selectors.productInput).val($(e.target).val());
            });
        };
        syncQuantity();
        //rating goto scrolling
        $(".Product__Rating").on("click", function() {
            const headerHeight = $(".Header").height();
            $([
                document.documentElement,
                document.body
            ]).animate({
                scrollTop: $("#shopify-section-product-reviews").offset().top - headerHeight
            }, 0);
        });
        //Sticky cart by scroll
        $(document).on("scroll", ()=>{
            let posY = window.scrollY, cartHeight = $(".StickyCart").height();
            const breakpoint = 600;
            if (posY >= breakpoint) {
                $(".StickyCart").css({
                    "visibility": "visible",
                    "transform": "translateY(0)"
                });
                $(".Footer").css({
                    "margin-bottom": `${cartHeight}px`
                });
            } else $(".StickyCart").css({
                "visibility": "hidden",
                "transform": "translateY(100%)"
            });
        });
        //select sync
        $(".Product__StickySelector").on("change", (e)=>{
            let value = e.target.value;
            $(".Product__HeroSelector").val(value).trigger("change");
        });
        $(".Product__HeroSelector").on("change", (e)=>{
            let value = e.target.value;
            $(".Product__StickySelector").val(value);
        });
        function getGuid() {
            let d = new Date().getTime();
            let d2 = performance && performance.now && performance.now() * 1000 || 0;
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
                let r = Math.random() * 16;
                if (d > 0) {
                    r = (d + r) % 16 | 0;
                    d = Math.floor(d / 16);
                } else {
                    r = (d2 + r) % 16 | 0;
                    d2 = Math.floor(d2 / 16);
                }
                return (c == "x" ? r : r & 0x7 | 0x8).toString(16);
            });
        }
        const prodEls = document.querySelectorAll('[data-section-type="product"]');
        prodEls.forEach((prod)=>{
            if (prod.querySelector(selectors.productJson) != null) {
                const productSingleObject = JSON.parse(prod.querySelector(selectors.productJson).innerHTML);
                const optionSelects = prod.querySelectorAll(selectors.singleOptionSelector);
                const variantSelect = prod.querySelector(selectors.originalSelectorId);
                if (optionSelects.length > 0 && variantSelect) // has option selects and variant select
                optionSelects.forEach((select)=>{
                    select.addEventListener("change", (e)=>{
                        let target = e.target;
                        let variants = productSingleObject.variants;
                        let option1 = [
                            ...optionSelects
                        ].find((optionSelect)=>{
                            return optionSelect.getAttribute("data-index") == "option1";
                        })?.value;
                        let option2 = [
                            ...optionSelects
                        ].find((optionSelect)=>{
                            return optionSelect.getAttribute("data-index") == "option2";
                        })?.value;
                        let option3 = [
                            ...optionSelects
                        ].find((optionSelect)=>{
                            return optionSelect.getAttribute("data-index") == "option3";
                        })?.value;
                        let selectedVariant = variants.find((variant)=>{
                            let varMatch = true;
                            if (option1) {
                                if (variant.option1 != option1) varMatch = false;
                            }
                            if (option2) {
                                if (variant.option2 != option2) varMatch = false;
                            }
                            if (option3) {
                                if (variant.option3 != option3) varMatch = false;
                            }
                            return varMatch;
                        });
                        if (selectedVariant) variantSelect.value = selectedVariant.id;
                    });
                });
            }
            const bundleForms = prod.querySelectorAll('form[data-bundle="true"]');
            bundleForms.forEach((bundleForm)=>{
                const formSubmits = bundleForm.querySelectorAll("[data-add-bundle-product]");
                formSubmits.forEach((formSubmit)=>{
                    formSubmit.addEventListener("click", (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        console.log("bundle form submitted");
                        const bundleID = getGuid();
                        const _main_bundle_name = bundleForm._main_bundle_name?.value || "";
                        const _main_bundle_link = bundleForm._main_bundle_link?.value || "";
                        const _main_bundle_sku = bundleForm._main_bundle_sku?.value || "";
                        const _main_bundle_image = bundleForm._main_bundle_image?.value || "";
                        // const _bundle_pricing = bundleForm._bundle_pricing?.value || 'parent';
                        const _bundle_discount = parseInt(bundleForm._bundle_discount?.value) || 0;
                        const bundle_products = bundleForm.querySelectorAll("[data-select-available] [data-option-available]");
                        const addToCartErrorContainerHero = $(bundleForm).find(selectors.addToCartErrorContainerHero);
                        let message = theme.strings.addToBundle;
                        let products_data = [];
                        let productQuantity = bundleForm.querySelector(selectors.productQuantity)?.value || "1";
                        let bundleDiscountRemainder = _bundle_discount % bundle_products.length;
                        let bundleDiscountSplitType = "even";
                        /* products_data.push({
                            quantity: productQuantity,
                            id: bundleForm.id.value,
                            properties: {
                                _bundle_parent: true,
                                _bundle_id: bundleID,
                                _bundle_item_count: bundle_products.length,
                                _bundle_pricing : (_bundle_pricing == 'parent' ? 'none' : 'full_discount'),
                                _main_bundle_name,
                                _main_bundle_link,
                                _main_bundle_sku
                            }
                        }) */ bundle_products.forEach((bundle_product)=>{
                            const itemPrice = parseInt(bundle_product.getAttribute("data-price")) || 0;
                            let itemDiscount = 0;
                            if (_bundle_discount > 0) {
                                itemDiscount = Math.floor(_bundle_discount / bundle_products.length);
                                if (bundleDiscountRemainder > 0) {
                                    itemDiscount++;
                                    bundleDiscountRemainder--;
                                }
                            }
                            if (itemDiscount > itemPrice) bundleDiscountSplitType = "all";
                        });
                        if (bundleDiscountSplitType == "even") bundleDiscountRemainder = _bundle_discount % bundle_products.length;
                        else bundleDiscountRemainder = _bundle_discount;
                        bundle_products.forEach((bundle_product, idx)=>{
                            const variant_id = bundle_product.value;
                            const itemPrice = parseInt(bundle_product.getAttribute("data-price")) || 0;
                            let itemDiscount = 0;
                            if (_bundle_discount > 0) {
                                if (bundleDiscountSplitType == "even") {
                                    itemDiscount = Math.floor(_bundle_discount / bundle_products.length);
                                    if (bundleDiscountRemainder > 0) {
                                        itemDiscount++;
                                        bundleDiscountRemainder--;
                                    }
                                } else {
                                    itemDiscount = Math.min(itemPrice, bundleDiscountRemainder);
                                    bundleDiscountRemainder = bundleDiscountRemainder - itemDiscount;
                                }
                            }
                            if (variant_id) products_data.push({
                                quantity: productQuantity,
                                id: variant_id,
                                properties: {
                                    _bundle_parent: idx == 0,
                                    _bundle_id: bundleID,
                                    _bundle_item_count: bundle_products.length,
                                    _main_bundle_name: // _bundle_pricing : (_bundle_pricing == 'child' ? 'none' : 'full_discount'),
                                    _main_bundle_name,
                                    _main_bundle_link: _main_bundle_link,
                                    _main_bundle_sku: _main_bundle_sku,
                                    _main_bundle_image: _main_bundle_image,
                                    _bundle_discount: _bundle_discount,
                                    _bundle_item_discount: itemDiscount
                                }
                            });
                        });
                        $.ajax({
                            url: "/cart/add.js",
                            cache: false,
                            type: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
                            },
                            data: JSON.stringify({
                                items: products_data
                            }),
                            dataType: "json",
                            success: function(response) {
                                if (addToCartErrorContainerHero.length) addToCartErrorContainerHero.slideUp();
                                /* setTimeout(function () {
                                    btn.children(selectors.addToCartText).html(theme.strings.adding);
                                }, 300) */ setTimeout(function() {
                                    $("body").trigger(":addToCart");
                                }, 1000);
                            /* setTimeout(function () {
                                    btn.children(selectors.addToCartText).html(message);
                                }, 1300) */ },
                            error: function(error) {
                                if (error.status === 422 && addToCartErrorContainerHero.length) {
                                    addToCartErrorContainerHero.text(error.responseJSON.description);
                                    addToCartErrorContainerHero.slideDown();
                                }
                            }
                        });
                    });
                });
            });
        });
        /**
         * Product section constructor. Runs on page load as well as Theme Editor
         * `section:load` events.
         * @param {string} container - selector for the section container DOM element
         */ function Product(container) {
            console.log("product binding");
            var $container = this.$container = $(container);
            var $stickyCart = this.$sticky = $(".StickyCart");
            // Stop parsing if we don't have the product json script tag when loading
            // section in the Theme Editor
            if (!$(selectors.productJson, this.$container).html()) return;
            var sectionId = this.$container.attr("data-section-id");
            this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || false,
                singleOptionSelector: selectors.singleOptionSelector,
                originalSelectorId: selectors.originalSelectorId,
                product: this.productSingleObject
            };
            this.settings = {};
            this.namespace = ".product";
            this.variants = new slate.Variants(options);
            this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
            this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this));
            this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this));
            if (this.$featuredImage.length > 0) {
                this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr("src"));
                slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
                this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this));
            }
            $(document).on("change", $(selectors.productQuantityInput), function() {
                var inputVal = $(".Product__QuantityInput").val();
                if (inputVal == "" || inputVal == false || isNaN(inputVal)) $(".Product__QuantityInput").val(1);
                if (!selectors.rechargeOptionInput.length) $("body").trigger(":calculationPrice");
            });
            $(selectors.form).on("submit", function(e) {
                e.preventDefault();
                if ($(this).hasClass("StickyCart__Wrapper")) $container.find(selectors.addToCart).first().trigger("click");
                else {
                    var _self = $(this), addToCartErrorContainer = $(this).find(selectors.addToCartErrorContainer), addToCartErrorContainerSticky = $(this).find(selectors.addToCartErrorContainerSticky), addToCartErrorContainerHero = $(this).find(selectors.addToCartErrorContainerHero), $shades = _self.find("[data-option-available]"), productQuantity = $(selectors.productQuantity).first().val(), btn = _self.find("[data-add-to-cart]"), products = [], products_data = [], message = theme.strings.addToCart;
                    if (productQuantity == "" || productQuantity == false) productQuantity = 1;
                    if (this.getAttribute("data-bundle") == "true") {
                        let _main_bundle_name = _self.find("#_main_bundle_name").val();
                        let _main_bundle_link = _self.find("#_main_bundle_link").val();
                        let _main_bundle_sku = _self.find("#_main_bundle_sku").val();
                        let _bundle_index = "_bundle_index1";
                        message = theme.strings.addToBundle;
                        $shades.each(function() {
                            var variant_id = $(this).val();
                            products.push(variant_id);
                        });
                        products.forEach(function(item, index) {
                            products_data.push({
                                quantity: productQuantity,
                                id: item,
                                properties: {
                                    _bundle_index: index,
                                    _main_bundle_name: _main_bundle_name,
                                    _main_bundle_link: _main_bundle_link,
                                    _main_bundle_sku: _main_bundle_sku
                                }
                            });
                        });
                    // products.sort();
                    // var current = null;
                    // var cnt = 0;
                    //
                    // for (var i = 0; i < products.length; i++) {
                    // 	if (products[i] != current) {
                    // 		if (cnt > 0) {
                    // 			products_data.push({
                    // 				quantity: cnt,
                    // 				id: current,
                    // 				properties: {_bundle_index: i, _main_bundle_name, _main_bundle_link, _main_bundle_sku}
                    // 			})
                    // 		}
                    // 		current = products[i];
                    // 		cnt = productQuantity;
                    //
                    // 	} else {
                    // 		cnt = +cnt + +productQuantity;
                    // 	}
                    // }
                    //
                    // if (cnt > 0) {
                    // 	products_data.push({
                    // 		quantity: cnt,
                    // 		id: current,
                    // 		properties: {_main_bundle_name, _main_bundle_link, _main_bundle_sku}
                    // 	})
                    // }
                    } else if ($(this).find(".rtx_buy_box").length) /* let _subscriptio_plan_name = _self
                            .find("[data-pdp-subscription-btn]:checked")
                            .attr("data-pdp-subscription-btn"); */ products_data.push({
                        [_self.find('select[name="id"]').attr("name")]: _self.find('select[name="id"]').val(),
                        [_self.find(".quantity__input").attr("name")]: _self.find(".quantity__input").val(),
                        /* [_self.find('select[name="selling_plan"]').attr("name")]: _self
                                .find('select[name="selling_plan"]')
                                .val(), */ selling_plan: _self.find('[name="selling_plan"]').val(),
                        selling_plan_name: _self.find("[data-pdp-subscription-btn]:checked").data
                    });
                    else products_data.push({
                        [_self.find('select[name="id"]').attr("name")]: _self.find('select[name="id"]').val(),
                        [_self.find(".quantity__input").attr("name")]: _self.find(".quantity__input").val()
                    });
                    /*
                    } else {
                        if ($(this).find('select[name="selling_plan"]').length) {
                            let _subscriptio_plan_name = _self.find('[data-subscriptio-plan-value]:checked').attr('data-subscriptio-plan-value');
                            
                            products_data.push({
                                [_self.find('select[name="id"]').attr('name')]: _self.find('select[name="id"]').val(),
                                [_self.find('.quantity__input').attr('name')]: _self.find('.quantity__input').val(),
                                [_self.find('select[name="selling_plan"]').attr('name')]: _self.find('select[name="selling_plan"]').val(),
                                properties: {_subscriptio_plan_name}
                            });
                        } else {
                            products_data.push({
                                [_self.find('select[name="id"]').attr('name')]: _self.find('select[name="id"]').val(),
                                [_self.find('.quantity__input').attr('name')]: _self.find('.quantity__input').val()
                            });
                        }
                    }
                    */ $.ajax({
                        url: "/cart/add.js",
                        cache: false,
                        type: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
                        },
                        data: JSON.stringify({
                            items: products_data
                        }),
                        dataType: "json",
                        success: function(response) {
                            if (addToCartErrorContainer.length) addToCartErrorContainerHero.slideUp();
                            setTimeout(function() {
                                btn.children(selectors.addToCartText).html(theme.strings.adding);
                            }, 300);
                            setTimeout(function() {
                                $("body").trigger(":addToCart");
                            }, 1000);
                            setTimeout(function() {
                                btn.children(selectors.addToCartText).html(message);
                            }, 1300);
                        },
                        error: function(error) {
                            if (error.status === 422 && addToCartErrorContainer.length) {
                                addToCartErrorContainer.text(error.responseJSON.description);
                                addToCartErrorContainerHero.slideDown();
                                addToCartErrorContainerSticky.css({
                                    "display": "block"
                                });
                                setTimeout(()=>{
                                    addToCartErrorContainerSticky.css({
                                        "transform": "translateX(-50%) translateY(0)",
                                        "opacity": "1"
                                    });
                                }, 10);
                                setTimeout(function() {
                                    // addToCartErrorContainerHero.slideUp();
                                    addToCartErrorContainerSticky.css({
                                        "transform": "translateX(-50%) translateY(100%)",
                                        "opacity": "0"
                                    });
                                    setTimeout(()=>addToCartErrorContainerSticky.css({
                                            "display": "none"
                                        }), 100);
                                }, 10000);
                            }
                        }
                    });
                }
            });
            //----For select a subscription through a custom input
            subscriptionChange();
            function subscriptionChange() {
                if (!selectors.rechargeOptionInput.length) return false;
                else $("[data-pdp-subscription-btn]").on("click", function(e) {
                    var valueForSearch = "";
                    if ($(this).hasClass("PDPSubscription__Option--Type")) {
                        valueForSearch = $(this).parent().find("input").attr("data-pdp-subscription-btn");
                        $(this).parents(".Product__CartForm").find("[" + valueForSearch + "] input").trigger("click");
                    } else {
                        valueForSearch = $(this).parent().find("input").attr("data-pdp-subscription-btn");
                        $(this).parents(".Product__CartForm").find(".rc_widget__option__plans__dropdown").val(valueForSearch);
                    }
                });
            }
            //----For change product price in sticky bar
            //changePriceInSticky()
            function changePriceInSticky() {
                if (!selectors.rechargeOptionInput.length) return false;
                else $(selectors.rechargeOptionInput).on("change", function(e) {
                    let currentPrice = $(this).attr("data-subscription-price");
                    $stickyCart.find(selectors.productPrice).html(currentPrice);
                });
            }
        }
        Product.prototype = $.extend({}, Product.prototype, {
            /**
             * Updates the DOM state of the add to cart button
             *
             * @param {boolean} enabled - Decides whether cart is enabled or disabled
             * @param {string} text - Updates the text notification content of the cart
             */ updateAddToCartState: function(evt) {
                var variant = evt.variant;
                if (variant) {
                    $(selectors.priceWrapper, this.$container).removeClass("hide");
                    $(selectors.priceWrapper, this.$sticky).removeClass("hide");
                } else {
                    $(selectors.addToCart, this.$container).attr("disabled", true);
                    $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                    $(selectors.priceWrapper, this.$container).attr("hide");
                    $(selectors.addToCart, this.$sticky).attr("disabled", true);
                    $(selectors.addToCartText, this.$sticky).html(theme.strings.unavailable);
                    $(selectors.priceWrapper, this.$sticky).addClass("hide");
                    return;
                }
                if (variant.available) {
                    $(selectors.addToCart, this.$container).attr("disabled", false);
                    $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
                    $(selectors.addToCart, this.$sticky).attr("disabled", false);
                    $(selectors.addToCartText, this.$sticky).html(theme.strings.addToCart);
                } else {
                    $(selectors.addToCart, this.$container).attr("disabled", true);
                    $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
                    $(selectors.addToCart, this.$sticky).attr("disabled", true);
                    $(selectors.addToCartText, this.$sticky).html(theme.strings.soldOut);
                }
            },
            /**
             * Updates the DOM with specified prices
             *
             * @param {string} productPrice - The current price of the product
             * @param {string} comparePrice - The original price of the product
             */ updateProductPrices: function(evt) {
                var variant = evt.variant;
                //Set product quantity field max-quantity
                let variant_quantity = $(this.$container).find(`[data-product-select] option[value="${evt.variant.id}"]`).data("quantity");
                $(selectors.quantityInput).data("quantity", variant_quantity);
                var $comparePrice = $(selectors.comparePrice, this.$container);
                var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
                $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
                $(selectors.productPrice, this.$sticky).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
                if (variant.compare_at_price > variant.price) {
                    $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                    $compareEls.removeClass("hide");
                } else {
                    $comparePrice.html("");
                    $compareEls.addClass("hide");
                }
            },
            /**
             * Updates the DOM with the specified image URL
             *
             * @param {string} src - Image src URL
             */ updateProductImage: function(evt) {
                var variant = evt.variant;
                var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
                this.$featuredImage.attr("src", sizedImgUrl);
            },
            /**
             * Event callback for Theme Editor `section:unload` event
             */ onUnload: function() {
                this.$container.off(this.namespace);
            }
        });
    }
};
var $7c5126ea5818fee1$export$2e2bcd8739ae039 = $7c5126ea5818fee1$var$product;


const $7016d0b9fffcc75b$var$qr_code = {
    init: ()=>{
        $(".qrps-option").on("click", function(e) {
            var idx = $(this).attr("data-option");
            var $wrapper = $(this).closest(".page-qr-wrapper");
            var $initBlock = $wrapper.find(".qr-init-block");
            var $productBlock = $wrapper.find('.qr-product-block[data-option="' + idx + '"]');
            var $postInitBlock = $productBlock.closest(".qr-post-init");
            var isMobile = false;
            var $mobileOnlyEl = $wrapper.find(".mobile-only");
            if ($mobileOnlyEl.length > 0) {
                //check if mobile only element is hidden
                if ($mobileOnlyEl.eq(0).css("display") == "none") isMobile = false;
                else isMobile = true;
            } else //check screen width against magic number
            if ($(window).width() < 768) isMobile = true;
            else isMobile = false;
            if ($productBlock) {
                $("body").addClass("qrps-selected");
                $productBlock.siblings(".qr-product-block").addClass("hide");
                $productBlock.removeClass("hide");
                $postInitBlock.removeClass("hide");
                $initBlock.addClass("is-selected");
                $wrapper.find(".qrps-option").removeClass("active");
                $wrapper.find('.qrps-option[data-option="' + idx + '"]').addClass("active");
                if (!isMobile) {
                    var targetScroll = $postInitBlock.offset().top - $("#MainContent").css("padding-top").replace("px", "") - 40;
                    $("html").animate({
                        scrollTop: targetScroll
                    }, 1200);
                }
            }
            $(".CollectionProducts__Wrapper").slick("unslick").slick(productRecommendationsSlickSettings);
            $(document).resize();
        });
        $(".qrp-return").on("click", function(e) {
            $("body").removeClass("qrps-selected");
            var $wrapper = $(this).closest(".page-qr-wrapper");
            $wrapper.find(".qr-init-block").removeClass("is-selected");
            $wrapper.find(".qr-post-init").addClass("hide");
            $wrapper.find(".qr-product-block").addClass("hide");
            $wrapper.find(".qrps-option").removeClass("active");
        });
    }
};
var $7016d0b9fffcc75b$export$2e2bcd8739ae039 = $7016d0b9fffcc75b$var$qr_code;


theme.QuickView = function() {
    var selectors = {
        quickView: "[data-quick-view]",
        closeQuickView: '[data-action="quick-view"]',
        quickViewCheckOut: "[data-quick-view-check-out]",
        addToCartErrorContainer: "[data-cart-error]"
    };
    function quickView() {
        function openDrawer(drawer) {
            var $overlay = $(".PageOverlay");
            drawer.attr("aria-hidden", false);
            $overlay.addClass("Is-visible").css("z-index", "17");
            bodyScrollLock.disableBodyScroll($(".QuickView__Item")[0]);
        }
        function closeCartDrawer(drawer, overlay) {
            overlay.removeClass("Is-visible").css("z-index", "11");
            drawer.attr("aria-hidden", true);
            bodyScrollLock.clearAllBodyScrollLocks();
            $("body").attr("style", "");
        }
        $(document).on("click", selectors.closeQuickView, function(e) {
            e.preventDefault();
            var $drawer = $("#" + $(this).attr("data-drawer-id"));
            var $overlay = $(".PageOverlay");
            closeCartDrawer($drawer, $overlay);
        });
        $(document).on("click", selectors.quickView, function(e) {
            e.preventDefault();
            var url = $(this).data("quick-view");
            $.ajax({
                url: url,
                method: "GET",
                success: function(data) {
                    var drawer = $("#quick-view.Drawer");
                    var drawerInner = $(".Drawer__QuickViewWrapper");
                    drawerInner.html(data);
                    setTimeout(function() {
                        openDrawer(drawer);
                    }, 300);
                }
            });
        });
        $(document).on("click", selectors.quickViewCheckOut, function(e) {
            e.preventDefault();
            var _self = $(this), variant = _self.parents(".CartItem__Info").find("[data-quick-add]").attr("data-variant-id"), quantity = _self.parents(".CartItem__Info").find(".quantity__input").val(), errorContainer = _self.siblings("[data-cart-error]"), redirect_url = "/checkout";
            if (quantity == undefined) quantity = 1;
            let products_data = [];
            //for bundle product
            if (this.hasAttribute("data-add-bundle-product")) {
                var products = [];
                var $shades = _self.siblings("[data-select-available]").find("[data-option-available]");
                errorContainer = _self.siblings("[data-cart-error]");
                $shades.each(function() {
                    var variant_id = $(this).val();
                    products.push(variant_id);
                });
                products.sort();
                for(var i = 0; i < products.length; i++)products_data.push({
                    quantity: quantity,
                    id: products[i]
                });
            } else products_data.push({
                quantity: quantity,
                id: variant
            });
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    items: products_data
                },
                dataType: "json",
                success: function() {
                    window.location.href = redirect_url;
                },
                error: function(error) {
                    console.log(error, _self, errorContainer);
                    if (error.status === 422 && errorContainer.length) {
                        errorContainer.text(error.responseJSON.description);
                        errorContainer.slideDown();
                        setTimeout(function() {
                            errorContainer.slideUp();
                        }, 10000);
                    }
                }
            });
        });
    }
    quickView();
    $(document).on("SMP::RELOAD", ()=>{
        quickView();
    });
}();


const $dbb7eefb7e8177e0$var$slider = {
    init: ()=>{
        const sliderEls = document.querySelectorAll(`[data-section-type='slider']`);
        sliderEls.forEach((slider)=>{
            // var $slider = $(`[data-section-type='slider']`);
            var $slider = $(slider);
            var config = $.parseJSON($slider.attr("data-slick-config"));
            if (config) $slider.slick(config);
            $slider.find(".slick-dots li").each(function() {
                if ($(this).hasClass("slick-active")) $(this).attr("aria-selected", true);
                $(this).find("button").attr("aria-label", `Go to slide ${$(this).text()}`);
            });
            $slider.on("afterChange", function() {
                $slider.find(".slick-dots li").removeAttr("aria-selected");
                $slider.find(".slick-dots .slick-active").attr("aria-selected", true);
            });
            if ($slider.hasClass("Hero__Slider")) $(document).on("shopify:section:select", function(e) {
                $slider.slick("unslick");
                $slider.find(".slick-slide").remove();
                $slider = $(".Hero__Slider");
                $slider.slick(config);
            });
        });
    }
};
var $dbb7eefb7e8177e0$export$2e2bcd8739ae039 = $dbb7eefb7e8177e0$var$slider;


const $77163deb09d55b04$var$sublp = {
    init: ()=>{
        // Scoped to Subscription LP template
        if ($("body.template-page-subscribe").length > 0) {
            let page = "body.template-page-subscribe";
            /* SubLP Why Sub updated slider nav */ $(`${page} .sublp-why-sub__items`).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                $(`${page} .sublp-why-sub__slider-nav-arrow-dots-item button[data-slide-index="${nextSlide}"]`).parent().attr("aria-selected", true).addClass("slide-current").siblings().removeAttr("aria-selected").removeClass("slide-current");
            });
            $(`${page} .sublp-why-sub__slider-nav-arrow-dots-item button[data-slide-index]`).on("click", function() {
                $(this).parent().attr("aria-selected", true).addClass("slide-current").siblings().removeAttr("aria-selected").removeClass("slide-current");
                $(`${page} .sublp-why-sub__items`).slick("slickGoTo", $(this).data("slide-index"));
            });
            /* SubLP Press updated slider nav */ $(`${page} .sublp-press__slider`).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                $(`${page} .sublp-press__slider-nav-arrow-dots-item button[data-slide-index="${nextSlide}"]`).parent().attr("aria-selected", true).addClass("slide-current").siblings().removeAttr("aria-selected").removeClass("slide-current");
            });
            $(`${page} .sublp-press__slider-nav-arrow-dots-item button[data-slide-index]`).on("click", function() {
                $(this).parent().attr("aria-selected", true).addClass("slide-current").siblings().removeAttr("aria-selected").removeClass("slide-current");
                $(`${page} .sublp-press__slider`).slick("slickGoTo", $(this).data("slide-index"));
            });
            /* SubLP Reviews updated slider nav */ $(`${page} .sublp-reviews__slider`).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                $(`${page} .sublp-reviews__slider-nav-arrow-dots-item button[data-slide-index="${nextSlide}"]`).parent().attr("aria-selected", true).addClass("slide-current").siblings().removeAttr("aria-selected").removeClass("slide-current");
            });
            $(`${page} .sublp-reviews__slider-nav-arrow-dots-item button[data-slide-index]`).on("click", function() {
                $(this).parent().attr("aria-selected", true).addClass("slide-current").siblings().removeAttr("aria-selected").removeClass("slide-current");
                $(`${page} .sublp-reviews__slider`).slick("slickGoTo", $(this).data("slide-index"));
            });
            /* FAQs control handling */ $(`${page} .sublp-faqs__item .question`).on("click", function() {
                let open = $(this).parent().attr("data-open");
                if (open === "true") $(this).parent().attr("data-open", false);
                else $(this).parent().attr("data-open", true);
            });
            // Category Switcher Section
            function switchCategory(product) {
                $(`${page} .sublp-buybox__wrapper`).attr("data-active", false);
                $(`${page} .sublp-buybox__wrapper[data-product='${product}']`).attr("data-active", true);
                $(".product-select").val(product);
                // Fix gallery
                let target = `${page} .sublp-buybox__wrapper[data-product='${product}']`;
                //console.log('fixing gallery');
                //console.log('target:', target);
                $(`${target} .Product__HeroSliderWrapper`).slick("resize");
                $(`${target} .Product__HeroSliderWrapper`).slick("reinit");
                $(`${target} .Product__HeroDots`).slick("resize");
            }
            $(`${page} .sublp-categories__item .cta`).on("click", function() {
                let product = $(this).data("product");
                switchCategory(product);
            });
            // Process each RTX widget
            $(`${page} .rtx-wrapper`).each(function() {
                // Set parent for scoping
                let product_id = $(this).data("product-id");
                let parent = `${page} .rtx-wrapper[data-product-id='${product_id}']`;
                //console.log('parent:', parent);
                // Buybox Parent
                let buybox_parent = `.sublp-buybox__wrapper[data-product='${$(this).parents(".sublp-buybox__wrapper").data("product")}']`;
                //console.log('buybox_parent:', buybox_parent);
                // Category Switcher Dropdown
                $(`${buybox_parent} .product-select`).on("change", function(e) {
                    switchCategory($(this).val());
                });
                // Fetch Product JSON
                let product_json = JSON.parse(document.getElementById(`product-data-${product_id}`).textContent);
                //console.log('product_json:', product_json);
                // Check for changed product ID
                let product_id_current;
                if ($(`${buybox_parent} .selection.js-selected`).length) product_id_current = $(`${buybox_parent} .selection.js-selected`).data("product-id");
                else product_id_current = product_id;
                var currentVar;
                function setSellingPlan(prod_id) {
                    var selectedOption = document.querySelector(`${parent} input[name="selling_plan_select"]:checked`);
                    console.log("selectedOption:", selectedOption);
                    if (selectedOption.value === "onetime") document.querySelector(`${parent} input[name="selling_plan"]`).value = "";
                    else document.querySelector(`${parent} input[name="selling_plan"]`).value = document.querySelector(`${parent} #rtx_option_plans_dropdown`).value;
                }
                document.querySelector(`${parent} #rtx_buy_box_${product_id_current} #rtx_option_plans_dropdown`).addEventListener("change", function(e) {
                    for(var i = 0; i < product_json.selling_plan_groups[0].selling_plans.length; i++){
                        var sellingPlans = product_json.selling_plan_groups[0].selling_plans[i];
                        if (Number(e.target.value) === sellingPlans.id) //document.querySelector('[data-pdp-subscription-btn]:checked').data = sellingPlans.name
                        $(`${parent} [data-pdp-subscription-btn]:checked`).attr("data-pdp-subscription-btn", sellingPlans.name);
                    }
                    setSellingPlan(product_id_current);
                });
                document.querySelectorAll(`${parent} #rtx_buy_box_${product_id_current} input[name="selling_plan_select"]`).forEach((radio)=>{
                    currentVariantId = product_json.variants[0].id;
                    for(var i = 0; i < product_json.variants.length; i++)if (product_json.variants[i].id === Number(currentVariantId)) {
                        currentVar = product_json.variants[i];
                        break;
                    }
                    //document.querySelector('[name="selling_plan"]').value = currentVar.selling_plan_allocations[0].selling_plan_id;
                    radio.addEventListener("change", function(e) {
                        console.log("radio changed!");
                        if ($(`${buybox_parent} .selection.js-selected`).length) product_id_current = $(`${buybox_parent} .selection.js-selected`).data("product-id");
                        else product_id_current = product_id;
                        console.log("product_id:", product_id);
                        console.log("product_id_current:", product_id_current);
                        console.log(`${parent} #rtx_buy_box_${product_id_current} input[name="selling_plan_select"]:checked`);
                        var selected = document.querySelector(`${parent} #rtx_buy_box_${product_id_current} input[name="selling_plan_select"]:checked`);
                        // PROBLEM
                        document.querySelectorAll(`${parent} #rtx_buy_box_${product_id_current} .rtx_option`).forEach((option)=>{
                            option.classList.remove(`rtx--active`);
                        });
                        console.log("selected:", selected);
                        selected.closest(`.rtx_option`).classList.add(`rtx--active`);
                        var currentVariantId1 = "";
                        if (!currentVariantId1) currentVariantId1 = product_json.variants[0].id;
                        for(var i = 0; i < product_json.variants.length; i++)if (product_json.variants[i].id === Number(currentVariantId1)) {
                            currentVar = product_json.variants[i];
                            break;
                        }
                        //document.querySelector('[name="id"]').value = currentVar.id;
                        document.querySelector(`${parent} [name="selling_plan"]`).value = currentVar.selling_plan_allocations[0].selling_plan_id;
                        if (document.querySelector(`${parent} #rtx_buy_box_${product_id_current} input[name="selling_plan_select"]:checked`).value === "subsave") {
                            // Show frequency drop-down
                            document.querySelectorAll(`${parent} #rtx_buy_box_${product_id_current} .rtx_option_plans`).forEach((plans)=>{
                                plans.style.display = "block";
                            });
                            // Update prices, handle quantity
                            let price = $(`${parent} .selection.js-selected`).data("selling-plan-price");
                            let price_fixed = (price / 100).toFixed(2);
                            //console.log(`sub price: ${price}, price_fixed: ${price_fixed} (rtx-pdp-simple)`);
                            $(`${parent} [data-product-price]`).html(`$${price_fixed}`);
                            $(`${parent} [data-product-price]`).attr("data-product-price", price);
                            document.getElementsByClassName("Product__QuantityInput Input Input--fz20 js-qty__num quantity__input")[0].value = 1;
                        //document.getElementsByClassName('Product__QuantityInput Input Input--fz20 js-qty__num quantity__input')[2].value = 1;
                        }
                        if (document.querySelector(`${parent} #rtx_buy_box_${product_id_current} input[name="selling_plan_select"]:checked`).value === "onetime") {
                            // Hide frequency drop-down
                            document.querySelectorAll(`${parent} #rtx_buy_box_${product_id_current} .rtx_option_plans`).forEach((plans)=>{
                                plans.style.display = "none";
                            });
                            document.querySelector(`${parent} #rtx_buy_box_${product_id_current} #rtx_option_plans_dropdown`).selectedIndex = 0;
                            var spgOneTimeValue = "";
                            document.querySelector(`${parent} [name="selling_plan"]`).value = spgOneTimeValue;
                            // Update prices, handle quantity
                            let price = $(`${parent} .selection.js-selected`).data("variant-price");
                            let price_fixed = (price / 100).toFixed(2);
                            //console.log(`otp price: ${price}, price_fixed: ${price_fixed} (rtx-pdp-simple)`);
                            $(`${parent} [data-product-price]`).html(`$${price_fixed}`);
                            $(`${parent} [data-product-price]`).attr("data-product-price", price);
                            document.getElementsByClassName("Product__QuantityInput Input Input--fz20 js-qty__num quantity__input")[0].value = 1;
                        //document.getElementsByClassName('Product__QuantityInput Input Input--fz20 js-qty__num quantity__input')[2].value = 1;
                        }
                    });
                });
            });
        }
    }
};
var $77163deb09d55b04$export$2e2bcd8739ae039 = $77163deb09d55b04$var$sublp;


/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */ theme.customerAddresses = function() {
    var $newAddressForm = $("#AddressNewForm");
    if (!$newAddressForm.length) return;
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
        hideElement: "AddressProvinceContainerNew"
    });
    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function() {
        var formId = $(this).data("form-id");
        var countrySelector = "AddressCountry_" + formId;
        var provinceSelector = "AddressProvince_" + formId;
        var containerSelector = "AddressProvinceContainer_" + formId;
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });
    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function() {
        $newAddressForm.toggleClass("hide");
    });
    $(".address-edit-toggle").on("click", function() {
        var formId = $(this).data("form-id");
        $("#EditAddress_" + formId).toggleClass("hide");
    });
    $(".address-delete").on("click", function() {
        var $el = $(this);
        var formId = $el.data("form-id");
        var confirmMessage = $el.data("confirm-message");
        if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) Shopify.postLink("/account/addresses/" + formId, {
            parameters: {
                _method: "delete"
            }
        });
    });
}();


/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */ theme.customerLogin = function() {
    var config = {
        recoverPasswordForm: "#RecoverPassword",
        hideRecoverPasswordLink: "#HideRecoverPasswordLink"
    };
    if (!$(config.recoverPasswordForm).length) return;
    checkUrlHash();
    resetPasswordSuccess();
    $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);
    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }
    function checkUrlHash() {
        var hash = window.location.hash;
        // Allow deep linking to recover password form
        if (hash === "#recover") toggleRecoverPasswordForm();
    }
    /**
   *  Show/Hide recover password form
   */ function toggleRecoverPasswordForm() {
        $("#RecoverPasswordForm").toggleClass("hide");
        $("#CustomerLoginForm").toggleClass("hide");
    }
    /**
   *  Show reset password success message
   */ function resetPasswordSuccess() {
        var $formState = $(".reset-password-success");
        // check if reset password form was successfully submited.
        if (!$formState.length) return;
        // show success message
        $("#ResetSuccess").removeClass("hide");
    }
}();


function $bff3b54e276cb5e9$var$throttle(callback, wait = 0, { start: start = true , middle: middle = true , once: once = false  } = {}) {
    let innerStart = start;
    let last = 0;
    let timer;
    let cancelled = false;
    function fn(...args) {
        if (cancelled) return;
        const delta = Date.now() - last;
        last = Date.now();
        if (start && middle && delta >= wait) innerStart = true;
        if (innerStart) {
            innerStart = false;
            callback.apply(this, args);
            if (once) fn.cancel();
        } else if (middle && delta < wait || !middle) {
            clearTimeout(timer);
            timer = setTimeout(()=>{
                last = Date.now();
                callback.apply(this, args);
                if (once) fn.cancel();
            }, !middle ? wait : wait - delta);
        }
    }
    fn.cancel = ()=>{
        clearTimeout(timer);
        cancelled = true;
    };
    return fn;
}
function $bff3b54e276cb5e9$var$debounce(callback, wait = 0, { start: start = false , middle: middle = false , once: once = false  } = {}) {
    return $bff3b54e276cb5e9$var$throttle(callback, wait, {
        start: start,
        middle: middle,
        once: once
    });
}
theme.GlobalCssVariables = function() {
    function setValues() {
        var headerHeight = $("header .Header").height();
        var announceHeight = $(".Header__Announcement").height();
        // set init values
        document.documentElement.style.setProperty("--total-header-height", (headerHeight + announceHeight || 0) + "px");
        document.documentElement.style.setProperty("--header-height", headerHeight + "px");
        document.documentElement.style.setProperty("--announce-height", announceHeight || "0px");
        // update size when change orientation
        setTimeout(()=>{
            headerHeight = $(".Header").height();
            document.documentElement.style.setProperty("--header-height", headerHeight + "px");
        }, 1000);
    }
    const debouncedSetValues = $bff3b54e276cb5e9$var$debounce(setValues, 200);
    setValues();
    $(window).on("orientationchange", function() {
        debouncedSetValues();
    });
    $(window).on("resize", function() {
        debouncedSetValues();
    });
    const initialHeaderSize = parseInt($("body").css("--header-height"));
    const onScroll = ()=>{
        const hasStickyAnnouncementBar = $(".Header__Announcement").hasClass("Header__Announcement--Sticky");
        const headerSize = $("header .Header").height();
        const announceSize = parseInt($("body").css("--announce-height") || 0);
        //Make announce NON_Sticky and Header sticky
        const scrollTreshold = hasStickyAnnouncementBar ? 1 : $(".Header__Announcement").height();
        if (!$(".Header__Announcement").length || window.pageYOffset >= scrollTreshold) {
            //Reduce sticky header x2 if scrolldown
            if (window.pageYOffset >= initialHeaderSize + announceSize && window.pageYOffset >= headerSize + announceSize) $(".Header .Header__Container").addClass("Header__Shrink");
            if (window.scrollY <= headerSize + announceSize) $(".Header .Header__Container").removeClass("Header__Shrink");
        } else $(".Header .Header__Container").removeClass("Header__Shrink");
    };
    const debouncedOnScroll = $bff3b54e276cb5e9$var$debounce(onScroll, 200);
    $(window).on("scroll", function() {
        debouncedOnScroll();
    });
};
theme.bodyScroll = function() {
    if ($("body").hasClass("Open--Menu")) $("body").css({
        "overflow": "hidden",
        "position": "sticky"
    });
    else $("body").css({
        "overflow": "auto",
        "position": "relative"
    });
};
theme.init = function() {
    theme.GlobalCssVariables();
    theme.bodyScroll();
};
$(theme.init);
$(document).on("keydown", function(e) {
    // Featured Products Key Controls
    let $sliderMain = $(".FeaturedProducts__Content");
    if ($(".FeaturedProducts__Thumbnail").is(":focus")) {
        if (e.keyCode == 37 || e.keyCode == 38) {
            e.preventDefault();
            $sliderMain.slick("slickPrev");
        }
        if (e.keyCode == 39 || e.keyCode == 40) {
            e.preventDefault();
            $sliderMain.slick("slickNext");
        }
    }
    let activeElement = document.activeElement;
    if (activeElement.nodeName.toLowerCase() == "a" || activeElement.nodeName.toLowerCase() == "li" && activeElement.getAttribute("role") == "button") {
        if (e.keyCode == 32) {
            e.preventDefault();
            activeElement.click();
            console.log("simulate button");
        }
    }
});
let $bff3b54e276cb5e9$var$$sliderThumbnails = $(".FeaturedProducts__Thumbnails");
$bff3b54e276cb5e9$var$$sliderThumbnails.on("afterChange", function() {
    $(".FeaturedProducts__Thumbnails .FeaturedProducts__Thumbnail").each(function() {
        $(this).attr("aria-selected", false);
    });
    $(".FeaturedProducts__Thumbnails .FeaturedProducts__Thumbnail.slick-current").attr("aria-selected", true).focus();
});
$(".Hero__Slider").on("afterChange", function() {
    console.log("hero changed");
    $(this).find(".Btn").attr("tabindex", "-1");
    $(this).find(".slick-current").find(".Btn").attr("tabindex", "0");
});
var $bff3b54e276cb5e9$var$selectors = {
    quickAdd: "[data-quick-add]"
};
$(document).on("click", $bff3b54e276cb5e9$var$selectors.quickAdd, function(e) {
    e.preventDefault();
    original_selector = $(this);
    console.log("original_selector (quickAdd)", original_selector);
    if (typeof window.srAddToCart == "function") window.srAddToCart($(this)[0]);
    var _self = $(this), errorContainer = _self.siblings("[data-cart-error]"), variant = $(this).attr("data-variant-id"), productQuantity = $(this).parents(".CartItem__Info").find(".quantity__input").val(), products_data = [], products = [], message = theme.strings.addToCart, productTitle = $(this).attr("data-item_name"), productPrice = $(this).attr("data-price"), productLink = $(this).attr("href");
    if (productQuantity == "" || productQuantity == false || productQuantity == undefined) productQuantity = 1;
    //for bundle product
    if (this.hasAttribute("data-add-bundle-product")) {
        var $shades = _self.siblings("[data-select-available]").find("[data-option-available]"), _main_bundle_name = _self.parent().find("#_main_bundle_name").val(), _main_bundle_link = _self.parent().find("#_main_bundle_link").val(), _main_bundle_sku = _self.parent().find("#_main_bundle_sku").val();
        errorContainer = _self.siblings("[data-cart-error]");
        message = theme.strings.addToBundle;
        $shades.each(function() {
            var variant_id = $(this).val();
            products.push(variant_id);
        });
        products.forEach(function(item, index) {
            products_data.push({
                quantity: productQuantity,
                id: item,
                properties: {
                    _bundle_index: index,
                    _main_bundle_name: _main_bundle_name,
                    _main_bundle_link: _main_bundle_link,
                    _main_bundle_sku: _main_bundle_sku
                }
            });
        });
    } else // let _subscriptio_plan_name = "noSubscription"
    products_data.push({
        quantity: productQuantity,
        id: variant
    });
    var item = {
        Name: productTitle,
        URL: productLink,
        Price: productPrice,
        ProductId: variant
    };
    _learnq.push([
        "track",
        "Added to Cart",
        {
            item: item
        }
    ]);
    $.ajax({
        url: "/cart/add.js",
        cache: false,
        type: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
        },
        data: JSON.stringify({
            items: products_data
        }),
        dataType: "json",
        success: function() {
            setTimeout(function() {
                _self.html(theme.strings.adding);
            }, 300);
            setTimeout(function() {
                renderCart();
            }, 1000);
            setTimeout(function() {
                _self.html(message);
            }, 1300);
        },
        error: function(error) {
            if (error.status === 422 && errorContainer.length) {
                errorContainer.text(error.responseJSON.description);
                errorContainer.slideDown();
                setTimeout(function() {
                    errorContainer.slideUp();
                }, 10000);
            }
        }
    });
});


// Init
$(function() {
    (0, $5360e0e42e381604$export$2e2bcd8739ae039).init();
    (0, $c0698e6676883e31$export$2e2bcd8739ae039).init();
    (0, $1c739f26630ae9d4$export$2e2bcd8739ae039).init();
    (0, $47900ec3d6a9aaae$export$2e2bcd8739ae039).init();
    (0, $b806f99d4ff2dc2b$export$2e2bcd8739ae039).init();
    (0, $70695669e66c53d4$export$2e2bcd8739ae039).init();
    (0, $c0544ef036311d51$export$2e2bcd8739ae039).init();
    (0, $e4945ec127c41669$export$2e2bcd8739ae039).init();
    // native_video.init()
    (0, $22826d8d58b054d6$export$2e2bcd8739ae039).init();
    (0, $bbd06ce61d639104$export$2e2bcd8739ae039).init();
    (0, $d02c32fe3290f392$export$2e2bcd8739ae039).init();
    (0, $4f9c27bad1a1736f$export$2e2bcd8739ae039).init();
    (0, $7c5126ea5818fee1$export$2e2bcd8739ae039).init();
    (0, $7016d0b9fffcc75b$export$2e2bcd8739ae039).init();
    // quick_view.init()
    (0, $dbb7eefb7e8177e0$export$2e2bcd8739ae039).init();
    (0, $77163deb09d55b04$export$2e2bcd8739ae039).init();
    $(document).on("SMP::RELOAD", ()=>{
        (0, $4f9c27bad1a1736f$export$2e2bcd8739ae039).init();
        (0, $1c739f26630ae9d4$export$2e2bcd8739ae039).init();
        (0, $7c5126ea5818fee1$export$2e2bcd8739ae039).init();
    });
});
$(document).ready(function() {
    //   var sections = new slate.Sections();
    //   sections.register('product', theme.Product);
    //   sections.register('slider', theme.Slider);
    //   sections.register('header', theme.Header);
    //   sections.register('newsletter', theme.Newsletter);
    //   sections.register('cart-drawer', theme.CartDrawer);
    //   sections.register('quick-view', theme.QuickView);
    //   sections.register('embed-native-video', theme.EmbedNativeVideo);
    //   sections.register('blog', theme.Blog);
    //   sections.register('article', theme.Article);
    //   sections.register('collections', theme.Collections);
    //   sections.register('faq', theme.Faq);
    //   sections.register('contact-us', theme.ContactUs);
    //   sections.register('product-out-of-stock', theme.ProductOutOfStock);
    //   sections.register('product-simple', theme.ProductSimple);
    //   sections.register('featured-products', theme.FeaturedProducts);
    //   sections.register('password', theme.Password);
    //   sections.register('qr-code', theme.QRCode);
    //   sections.register('sublp', theme.SublP);
    // Fix stamped labels
    setTimeout(function() {
        $(".stamped-badge").each(function() {
            let label = $(this).attr("aria-label");
            let $new_label = $(`<span class="sr-only">${label}</span>`);
            $new_label.insertBefore(this);
            $(this).removeAttr("aria-label");
        });
        $(".stamped-main-badge").each(function() {
            var oldEl = this;
            var newEl = document.createElement("a");
            newEl.id = "StampedMainBadgeA";
            newEl.setAttribute("data-id", oldEl.getAttribute("data-id"));
            newEl.setAttribute("data-product-sku", oldEl.getAttribute("data-product-sku"));
            newEl.setAttribute("data-product-title", oldEl.getAttribute("data-product-title"));
            newEl.setAttribute("data-product-type", oldEl.getAttribute("data-product-type"));
            newEl.className = oldEl.className;
            newEl.href = "#stamped-reviews-tab";
            while(oldEl.childNodes.length > 0)newEl.appendChild(oldEl.childNodes[0]);
            newEl.addEventListener("keydown", function(e) {
                if (e.keyCode === 13 || e.keyCode == 32) {
                    e.preventDefault();
                    var hrefVal = e.target.href;
                    hrefVal = hrefVal.substr(hrefVal.indexOf("#") + 1);
                    var mainWidget = document.getElementById(hrefVal);
                    mainWidget.focus();
                }
            });
            oldEl.replaceWith(newEl);
        });
    }, 1000);
    /* Updated slider nav accessibility handling */ const navs = [];
    navs.push({
        "slider": ".Hero__Slider",
        "nav": ".Hero__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".FeaturedProducts__Content",
        "nav": ".FeaturedProducts__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".BWT__ProductsWrapper",
        "nav": ".BWT__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".sublp-reviews__slider",
        "nav": ".sublp-reviews__slider-nav-arrow-dots-item"
    });
    navs.push({
        "slider": ".CollectionProducts__Wrapper",
        "nav": ".CollectionProducts__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".BlogArticles__Wrapper",
        "nav": ".BlogArticles__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".Product__HeroSliderWrapper:not([data-combined-handle])",
        "nav": ".Product__SliderNavDotsItem:not([data-combined-handle])"
    });
    navs.push({
        "slider": ".ProductSelector__Content",
        "nav": ".ProductSelector__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".PCC__ProductsWrapper",
        "nav": ".PCC__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".CCC__CardsWrapper",
        "nav": ".CCC__SliderNavDotsItem"
    });
    navs.push({
        "slider": ".Product__HeroSliderWrapper:not([data-combined-handle])",
        "nav": ".Product__HeroDots:not([data-combined-handle])"
    });
    const combinedHeroSliders = document.querySelectorAll(".Product__HeroSliderWrapper[data-combined-handle]");
    combinedHeroSliders.forEach((heroSlider)=>{
        const handle = heroSlider.getAttribute("data-combined-handle");
        navs.push({
            "slider": `.Product__HeroSliderWrapper[data-combined-handle="${handle}"]`,
            "nav": `.Product__SliderNavDotsItem[data-combined-handle="${handle}"]`
        });
        navs.push({
            "slider": `.Product__HeroSliderWrapper[data-combined-handle="${handle}"]`,
            "nav": `.Product__HeroDots[data-combined-handle="${handle}"]`
        });
    });
    navs.forEach(function(group, index) {
        setTimeout(function() {
            $(`${group.slider}`).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                let siblingFilter = "";
                if ($(`${group.nav}`).attr("data-combined-handle")) {
                    const handle = $(`${group.nav}`).attr("data-combined-handle");
                    siblingFilter = `[data-combined-handle="${handle}"]`;
                }
                $(`${group.nav} button[data-slide-index="${nextSlide}"]`).attr("aria-current", true).parent().siblings(siblingFilter).children().removeAttr("aria-current");
                $(`${group.nav} button[data-slide-index="${nextSlide}"]`).parent().addClass("slide-current").siblings(siblingFilter).removeAttr("aria-selected").removeClass("slide-current");
                $(`${group.nav} li[role="button"][data-slick-index="${nextSlide}"]`).attr("aria-current", true).siblings().removeAttr("aria-current");
                $(`${group.nav} li[role="button"][data-slick-index="${nextSlide}"]`).addClass("slide-current").siblings().removeAttr("aria-selected").removeClass("slide-current");
            });
            $(`${group.nav} button[data-slide-index]`).on("click", function() {
                let siblingFilter = "";
                if ($(`${group.nav}`).attr("data-combined-handle")) {
                    const handle = $(`${group.nav}`).attr("data-combined-handle");
                    siblingFilter = `[data-combined-handle="${handle}"]`;
                }
                $(this).attr("aria-current", true).parent().siblings(siblingFilter).children().removeAttr("aria-current");
                $(this).parent().addClass("slide-current").siblings(siblingFilter).removeAttr("aria-selected").removeClass("slide-current");
                $(`${group.slider}`).slick("slickGoTo", $(this).data("slide-index"));
            });
            let curIndex = $(`${group.slider} .slick-active`).data("slick-index");
            $(`${group.nav} li[role="button"][data-slick-index="${curIndex}"]`).attr("aria-current", true);
        }, 1000);
    });
    // Intelligems Handling
    const igData = window.igData;
    if (typeof igData !== "undefined") {
        if (typeof igData?.user?.getExperiments()[0]?.id === "undefined") console.log("IG (Theme) - No experiments.");
        else {
            console.log("IG (Theme) - Found experiments.");
            let experimentId = igData.user.getExperiments()[0].id;
            let testGroup = igData.user.getTestGroup(experimentId);
            let fsThreshold = String(testGroup.freeShippingThreshold).replace(/^\D+/g, "") * 100;
            console.log(`IG (Theme) - fsThreshold: ${fsThreshold}`);
            if (fsThreshold) {
                // Verify that threshold exists
                if ($(`body`).hasClass("template-product")) {
                    // PDP - body.template-product
                    console.log(`IG (Theme) - Updating PDP.`);
                    let layoutTest = $(`.Product__SelectorWrapper .selection`).length;
                    console.log(`IG (Theme) - layoutTest: ${layoutTest}`);
                    // Check for PDP layout type
                    if (layoutTest <= 0) {
                        // Single layout
                        console.log(`IG (Theme) - Single layout.`);
                        // Remove gallery badges (single layout)
                        $(`.ProductCard__Badges--Big .Badge--Up`).remove();
                        let priceOTP = $(`.Product__Hero [data-product-price]`).data("product-price");
                        console.log(`IG (Theme) - priceOTP: ${priceOTP}`);
                        if (priceOTP >= fsThreshold) {
                            // Gallery badge
                            let $galleryBadge = $(`
                <div class="Badge--Up">
                  <div class="Badge">
                    <span style="background-color: #0d9ed6; color: #000000;">Free Shipping</span>
                  </div>
                </div>
              `);
                            $(`.ProductCard__Badges--Big`).prepend($galleryBadge);
                        }
                    } else {
                        // Combined layout
                        console.log(`IG (Theme) - Combined layout.`);
                        $(`.Product__SelectorWrapper .selection`).each(function() {
                            // Remove selector badge
                            $(this).children(".pdp-badge").remove();
                            // Remove gallery badges
                            let productHandle = $(this).data("combined-handle");
                            $(`.ProductCard__Badges[data-combined-handle='${productHandle}'] .Badge--Up`).remove();
                            let priceOTP = $(this).data("variant-price");
                            console.log(`IG (Theme) - priceOTP: ${priceOTP}`);
                            if (priceOTP >= fsThreshold) {
                                console.log("IG (Theme) - Free shipping!");
                                // Selector badge
                                let $badge = $(`<div class="pdp-badge">Free Shipping</div>`);
                                $(this).append($badge);
                                // Gallery badge
                                let $galleryBadge = $(`
                  <div class="Badge--Up">
                    <div class="Badge">
                      <span style="background-color: #0d9ed6; color: #000000;">Free Shipping</span>
                    </div>
                  </div>
                `);
                                $(`.ProductCard__Badges[data-combined-handle='${productHandle}']`).prepend($galleryBadge);
                            }
                        });
                    }
                } else {
                    // All other templates
                    console.log(`IG (Theme) - Updating badges.`);
                    $(".ProductCard__Badges").each(function() {
                        $(this).children(".Badge--Up").remove();
                        let price = $(this).parent(".ProductCardWrapper").find("[data-product-price]").data("product-price");
                        console.log(`IG (Theme) - price: ${price}`);
                        if (price >= fsThreshold) {
                            console.log("IG (Theme) - Free shipping!");
                            let $badge = $(`
                <div class="Badge--Up">
                  <div class="Badge">
                    <span style="background-color: #0d9ed6; color: #000000;">Free Shipping</span>
                  </div>
                </div>
              `);
                            $(this).prepend($badge);
                        }
                    });
                }
            }
        }
    } else console.log("IG - Not found.");
});

})();
